/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import moment from 'moment';
import { Dropdown, Button } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import TextField from '@material-ui/core/TextField';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import DateFnsUtils from '@date-io/date-fns';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ContractManufacturer from './ContractManufacturer';
import DuplicateContractModal from './DuplicateContractModal';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import {
  dispatchTabValue,
  getDrugSpecialist,
  getLetterSenderDetails,
  getContractContactType,
  getAllContractDetails,
  dispatchAllContractDetails,
  getContractSequenceNum,
  dispatchCoverageTable,
  errorMaintainContractActions,
  dispatchDrugTable,
  getValidateContract,
  dispatchValidateContract,
  maintainContractActions,
  getCreateAndUpdateContract,
  getExistingCorrLinkIds,
  handleErrorMessages,
  dispatchInitialResponse,
  dispatchCellClick,
  getNewContractSequenceNum,
  searchContractActions,
  dispatchCreateAndUpdateContract,
  dispatchWriteOffDate,
  dispatchUndoWriteOffDate,
  dispatchDeleteDrugFamily,
  dispatchDeleteCoverageGap,
  dispatchInitialCoverageGap,
  dispatchInvContactDetails,
  dispatchDisputeContactDetails,
  dispatchSelectContractForDisputeContact,
  dispatchSelectContractForInvoiceContact,
  getReferences,
  fetchAllCommonDrugFamilyContractDropdownList,
  getDisputeContactDetails,
} from '../store/actions';
import {
  setSelectManufacturerData,
  fetchAllManufacturerDetail,
  getContactDetails,
  maintainLabelerListData,
  setMaintainManufacturerTab,
} from '../../Manufacturer/store/ManufacturerAction';
import {
  closeTab,
  redirectURLLink,
  convertPDFFromAPI,
  validDate,
  handleScrollToEvent,
  handleQuarterFormate,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import * as Constants from '../../../../SharedModules/AppConstants';
import Drugfamilies from './DrugFamilies';
import Calc from './Calc';
import Detail from './Detail';
import CoverageGap from './CoverageGap';
import OtherContact from './OtherContact';
import DisputeContact from './DisputeContact';
import InvoiceContact from './InvoiceContact';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';

import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import {
  MinDate,
  MaxDate,
  dateFormatForDatePicker,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../SharedModules/DateUtilities/DateUtilities';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import {
  checkActionAccessByRole,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import { getPlanTypeDesc } from '../../RebatePriceLevel/store/actions';
import { getRebatePgmDetail } from '../../RebateProgram/SearchRebate/store/actions';

// Fields used to detect Invoice/Dispute/Other Contact dirty state (ignore audit fields).
const CONTRACT_CONTACT_COMPARE_FIELDS = [
  'contactSeqNum',
  'contactTypeCd',
  'contactTypeCode',
  'contactName',
  'corpName',
  'addrLine1',
  'addrLine2',
  'addrLine3',
  'city',
  'stateCd',
  'zip',
  'zip4',
  'phoneNum',
  'phoneExtension',
  'faxNum',
  'email',
  'manufacturerID',
];

const normalizeContractContactField = (value) => {
  if (value === null || value === undefined) return '';
  return typeof value === 'string' ? value.trim() : String(value);
};

const getComparableContractContact = (contact = {}) => {
  return CONTRACT_CONTACT_COMPARE_FIELDS.reduce((acc, field) => {
    acc[field] = normalizeContractContactField(contact?.[field]);
    return acc;
  }, {});
};

const isContractContactUnchanged = (current, original) => {
  if (!original) return false;
  return _.isEqual(
    getComparableContractContact(current),
    getComparableContractContact(original)
  );
};

const getComparableOtherContactList = (list = []) => {
  return (list || [])
    .map((item) => getComparableContractContact(item))
    .sort((a, b) =>
      normalizeContractContactField(a.contactTypeCd).localeCompare(
        normalizeContractContactField(b.contactTypeCd)
      )
    );
};

const isOtherContactListUnchanged = (currentList, originalList) => {
  if (!originalList) return false;
  return _.isEqual(
    getComparableOtherContactList(currentList),
    getComparableOtherContactList(originalList)
  );
};

const CreateContact = () => {
  const history = useHistory();
  const RedColor = '#a81f00';
  const [tabValue, setTabValue] = React.useState('one');
  const [loading, setLoading] = React.useState(false);
  const [createValidate, setCreateValidate] = React.useState(false);
  const [isSaveOpen, setIsSaveOpen] = React.useState(false);
  const [isCancelOpen, setIsCancelOpen] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState([]);
  const [keyValue, setKeyValue] = React.useState([]);
  const [showViewHistory, setShowViewHistory] = React.useState(false);
  const [showComments, setShowComments] = React.useState(false);
  const [corrLinkId, setCorrLinkId] = React.useState(null);
  const [commentShow, setCommentShow] = React.useState(false);
  const [callValidateContract, setCallValidateContract] = React.useState(false);
  const [duplicatePop, setDuplicatePopUp] = React.useState(false);
  const [duplicateContractPopUp, setDuplicateContractPopUp] =
    React.useState(false);
  const [duplicateAction, setDuplicateAction] = React.useState(false);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = React.useState(false);
  const [openDuplicatePop, setOpenDuplicatePop] = React.useState(false);
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(
      process.env.REACT_APP_MAINTAIN_CHECK_DISABLE_ROLE,
      kcRoles
    )
  );

  const dispatch = useDispatch();
  const getTabValue = useSelector(
    (state) => state.sharedState.ContractReducer.tabValue
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = today.getMonth() + 1; // Months start at 0!
  const dd = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
  const currDate = `${mm}/${dd}/${yyyy}`;
  // const logInUserID = localStorage.getItem('logInUser');

  const handleChangeTabValue = (event, newValue) => {
    dispatch(dispatchTabValue(newValue));
    let localErr = errorMessagesFromRedux || [];
    localErr = localErr?.filter(
      (item) => item.message !== constantMessageData.CONTRACT_NO_CALCULATED_URA
    );
    dispatch(handleErrorMessages([...new Set(localErr)]));
    setSuccessMessage([]);
  };
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(
          process.env.REACT_APP_MAINTAIN_CHECK_DISABLE_ROLE,
          kcRoles
        )
      );
    }
  }, []);

  React.useEffect(() => {
    setTabValue(getTabValue);
  }, [getTabValue]);
  const [formValue, setFormValue] = React.useState({
    fromDate: null,
    toDate: null,
    rebateProgramCode: '-1',
    drugPricing: false,
  });
  const selected_type = useSelector(
    (state) => state?.sharedState?.ContractReducer?.selected_type
  );
  const maintainContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.maintainContractState
  );
  const otherContract = useSelector(
    (state) =>
      state.sharedState.ContractReducer?.maintainContractState?.otherContract
  );
  const disputeContract = useSelector(
    (state) =>
      state.sharedState.ContractReducer?.maintainContractState?.disputeContract
  );
  const errorOtherContract = useSelector(
    (state) =>
      state.sharedState.ContractReducer?.maintainContractState
        ?.errorOtherContract
  );
  const errordisputeContract = useSelector(
    (state) =>
      state.sharedState.ContractReducer?.maintainContractState
        ?.errordisputeContract
  );
  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const getAllContractData = useSelector(
    (state) => state.sharedState?.ContractReducer?.getAllContractData
  );
  const errorMaintainContract = useSelector(
    (state) => state.sharedState?.ContractReducer?.errorMaintainContract
  );
  const getContactType = useSelector(
    (state) => state?.sharedState?.ContractReducer?.getContactType
  );
  const getDrugFamilyTable = useSelector(
    (state) => state.sharedState?.ContractReducer?.getDrugFamilyTable
  );
  const getValidatedContract = useSelector(
    (state) => state.sharedState.ContractReducer.getValidatedContract
  );
  const getCoverageTable = useSelector(
    (state) => state.sharedState?.ContractReducer?.getCoverageTable
  );
  const invoiceContact = useSelector(
    (state) =>
      state.sharedState?.ContractReducer?.maintainContractState?.invoiceContact
  );
  const listOfOtherContact = useSelector(
    (state) =>
      state.sharedState?.ContractReducer?.maintainContractState
        ?.listOfOtherContact
  );
  // Baselines for contact tabs — Save enable/disable + empty request payload.
  const originalInvoiceContactRef = React.useRef(null);
  const originalDisputeContactRef = React.useRef(null);
  const originalListOfOtherContactRef = React.useRef(null);
  const [invoiceContactDirty, setInvoiceContactDirty] = React.useState(false);
  const [disputeContactDirty, setDisputeContactDirty] = React.useState(false);
  const [otherContactDirty, setOtherContactDirty] = React.useState(false);
  const isContactTabsDirty =
    invoiceContactDirty || disputeContactDirty || otherContactDirty;
  const isSaveDisabled =
    maintainContractState.showSaveButton == 'No' && !isContactTabsDirty;

  const setContactBaselines = (invoice, dispute, otherList) => {
    originalInvoiceContactRef.current = JSON.parse(
      JSON.stringify(invoice || {})
    );
    originalDisputeContactRef.current = JSON.parse(
      JSON.stringify(dispute || {})
    );
    originalListOfOtherContactRef.current = JSON.parse(
      JSON.stringify(otherList || [])
    );
    setInvoiceContactDirty(false);
    setDisputeContactDirty(false);
    setOtherContactDirty(false);
  };

  React.useEffect(() => {
    if (!originalInvoiceContactRef.current) return;
    setInvoiceContactDirty(
      !isContractContactUnchanged(
        invoiceContact,
        originalInvoiceContactRef.current
      )
    );
  }, [invoiceContact]);

  React.useEffect(() => {
    if (!originalDisputeContactRef.current) return;
    setDisputeContactDirty(
      !isContractContactUnchanged(
        disputeContract,
        originalDisputeContactRef.current
      )
    );
  }, [disputeContract]);

  React.useEffect(() => {
    if (!originalListOfOtherContactRef.current) return;
    setOtherContactDirty(
      !isOtherContactListUnchanged(
        listOfOtherContact,
        originalListOfOtherContactRef.current
      )
    );
  }, [listOfOtherContact]);
  const calTab = useSelector(
    (state) => state.sharedState?.ContractReducer?.maintainContractState?.calTab
  );
  const manufacturerTab = useSelector(
    (state) =>
      state.sharedState?.ContractReducer?.maintainContractState?.manufacturerTab
  );
  const detailTab = useSelector(
    (state) =>
      state.sharedState?.ContractReducer?.maintainContractState?.detailTab
  );
  const createUpdateContract = useSelector(
    (state) => state.sharedState?.ContractReducer?.createUpdateContract
  );
  const initialResponse = useSelector(
    (state) => state.sharedState?.ContractReducer?.initialResponse
  );
  const onClickCell = useSelector(
    (state) => state.sharedState?.ContractReducer?.onClickCell
  );
  const commentsList = useSelector(
    (state) => state.sharedState.CommentsReducer.CommentListData
  );
  const newContractSeqNum = useSelector(
    (state) => state.sharedState.ContractReducer.newContractSeqNum
  );
  const errorMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.ContractReducer?.errorMessagesInRedux;
  });
  const getWriteOffDate = useSelector(
    (state) => state.sharedState.ContractReducer.getWriteOffDate
  );
  const getUndoWriteOffDate = useSelector(
    (state) => state.sharedState.ContractReducer.getUndoWriteOffDate
  );
  const deleteDrugFamily = useSelector(
    (state) => state.sharedState.ContractReducer.deleteDrugFamily
  );
  const deleteCoverageGap = useSelector(
    (state) => state.sharedState.ContractReducer.deleteCoverageGap
  );
  const rebatePgmView = useSelector(
    (state) => state?.sharedState?.SearchRebateReducer?.pgm_res
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const hasRole = (role) =>
    kcRoles?.userPrivileges?.some((r) => r === role) || false;

  // Normal User may edit Manufacturer and Other Contacts tab fields
  const canNormalUserEditTabs = hasRole('Normal User');
  const isNormalUserTabEditable = isEnablebyRole || canNormalUserEditTabs;

  const [getDataAfterSave, setGetDataAfterSave] = React.useState(false);

  // on load use effect
  React.useEffect(() => {
    dispatch(getDrugSpecialist(''));
    dispatch(getLetterSenderDetails(''));
    dispatch(dispatchWriteOffDate(''));
    dispatch(dispatchUndoWriteOffDate(''));
    handleScrollToEvent();
    dispatch(
      fetchAllCommonDrugFamilyContractDropdownList({
        codeDomainList: [
          'REBATE_PRICING_METHOD_CD',
          'VOLUME_CALC_METHOD_CD',
          'MKT_SHARE_CALC_METHOD_CD',
          'NAT_MKT_SHARE_TYPE_CD',
        ],
      })
    );
    dispatch(getReferences({}));
    dispatch(
      getContractContactType({
        keyTypeCd: 'CONTRACT',
      })
    );
    dispatch(errorMaintainContractActions([]));
    if (searchContractState.contractType === 'onSelect' && onClickCell) {
      dispatch(dispatchInitialResponse(true));
      setLoading(true);
      dispatch(dispatchCellClick(false));
      const newData = {
        searchType: selected_type,
        rebateProgram:
          selected_type === Constants.MANUFACTURER_REBATE_ID
            ? searchContractState.rebateProgramCode
            : null,
        quarter:
          selected_type === Constants.MANUFACTURER_REBATE_ID
            ? searchContractState.getQuarter
            : null,
        mfgId:
          searchContractState.selectedContractType === 'mfgId'
            ? searchContractState.selectedRowData
            : null,
        drugFamilyId:
          searchContractState.selectedContractType === 'drugFamilyId'
            ? searchContractState.selectedRowData
            : null,
        marketBasketId:
          searchContractState.selectedContractType === 'marketBasketId'
            ? searchContractState.selectedRowData
            : null,
        contractId: searchContractState.selectedContractId,
        // searchContractState.selectedContractType === 'contractId'
        //   ? searchContractState.selectedRowData
        //   : null,
        asOfDate:
          selected_type === Constants.MANUFACTURER_REBATE_ID
            ? null
            : searchContractState.searchContractDate,
        keyTypeCd: 'CONTRACT',
        planType: searchContractState.planType,
      };
      dispatch(getAllContractDetails(newData));
    } else if (onClickCell) {
      dispatch(dispatchInitialResponse(true));
      dispatch(getContractSequenceNum());
      dispatch(dispatchAllContractDetails({}));
      dispatch(dispatchCellClick(false));
    }
  }, []);

  // set comment icon on if corrLinkId and comment is available
  const handleExistingCommentList = async (data) => {
    setCorrLinkId(data?.corrLinkId);
    if (data) {
      const result = await getExistingCorrLinkIds({
        corrLinkId: [data.corrLinkId],
      });
      if (result && result.data?.length > 0) {
        result.data.forEach((elem) => {
          if (elem === data.corrLinkId) {
            setCommentShow(true);
          }
        });
      } else {
        setCommentShow(false);
      }
    }
  };

  const validateContract = (type = '') => {
    if (searchContractState.contractType === 'onSelect' || type == 'Save') {
      setLoading(true);
      dispatch(
        getValidateContract({
          contractSeqNum:
            getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
              .contractSeqNum,
          userId: logInUser,
          date: currDate,
          contractName:
            getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
              .contractName,
        })
      );
    } else if (validateRequest()) {
      setCreateValidate(true);
    }
  };

  React.useEffect(() => {
    if (getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab) {
      handleExistingCommentList(
        getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
      );
    }
  }, [commentsList]);
  // React.useEffect(() => {
  // }, [searchContractState.contractType]);
  React.useEffect(() => {
    if (getValidatedContract && getValidatedContract != '') {
      setLoading(false);
      setCreateValidate(false);
      convertPDFFromAPI(getValidatedContract);
      dispatch(dispatchValidateContract(''));
    }
  }, [getValidatedContract]);
  React.useEffect(() => {
    if (createUpdateContract && createUpdateContract === '001') {
      setGetDataAfterSave(true);
      if (!clickOncloseTabBtn) {
        closeTab('/createContract', history, dispatch);
      }
      dispatch(dispatchCreateAndUpdateContract(''));
      dispatch(dispatchInvContactDetails({}));
      dispatch(dispatchDisputeContactDetails({}));
      // dispatch(dispatchSelectContractForDisputeContact([]));
      // dispatch(dispatchSelectContractForInvoiceContact([]));
      handleScrollToEvent();
      setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      if (!duplicateAction) {
        const data = {
          ...maintainContractState,
          showSaveButton: 'No',
        };
        const newData1 = {
          ...searchContractState,
          contractType: 'onSelect',
        };
        dispatch(searchContractActions(newData1));
        dispatch(maintainContractActions(data));
        dispatch(dispatchInitialResponse(true));
        const date = new Date(maintainContractState.contractStartDate);
        date.setDate(date.getDate() + 1);
        const newData = {
          searchType: 'C',
          contractId: maintainContractState.contractSeqNum,
          asOfDate: moment(date).format('MM/DD/YYYY'),
        };
        dispatch(getAllContractDetails(newData));
      } else {
        setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      }
    }
    setIsSaveOpen(false);
    setLoading(false);
    if (duplicateContractPopUp && openDuplicatePop) {
      setDuplicateContractPopUp(true);
    } else setDuplicateContractPopUp(false);
    setDuplicateAction(false);
  }, [createUpdateContract]);
  React.useEffect(() => {
    if (getWriteOffDate == 'Contract Write off success') {
      setSuccessMessage([constantMessageData.WRITE_OFF_SUCCESS]);
    }
  }, [getWriteOffDate]);
  React.useEffect(() => {
    if (getUndoWriteOffDate == 'Contract Undo Write off success') {
      setSuccessMessage([constantMessageData.UNDO_WRITE_OFF]);
    }
  }, [getUndoWriteOffDate]);
  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesFromRedux && errorMessagesFromRedux.length > 0) {
      tabHighLigther('/createContract', true);
    } else {
      tabHighLigther('/createContract', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj = updateTabs?.map((item) => {
      if (
        item.navTo === '/createContract' &&
        (maintainContractState?.showSaveButton == 'Yes' || isContactTabsDirty)
      ) {
        item.isFormDirty = true;
      } else if (item.navTo === '/createContract') item.isFormDirty = false;
      return item;
    });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [maintainContractState, isContactTabsDirty]);
  // handle close and confirm popup
  React.useEffect(() => {
    if (createUpdateContract && createUpdateContract === '001') {
      dispatch(dispatchCreateAndUpdateContract(''));
    }
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/createContract' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/createContract' && item.isFormSave) {
          item.isFormSave = false;
          onSubmit(false);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  const handleOnChangeEvent = (e, name) => {
    const data = {
      ...maintainContractState,
      showSaveButton: 'Yes',
      [name]: e.target.value,
    };
    dispatch(maintainContractActions(data));
    setSuccessMessage([]);
    const errorShown = [...errorMessagesFromRedux];
    const error = errorShown.filter(
      (e) => e.message !== constantMessageData.END_DATE_PROVIDED
    );
    const localErr = error?.filter(
      (item) => item.message !== constantMessageData.CONTRACT_NO_CALCULATED_URA
    );
    dispatch(handleErrorMessages([...new Set(localErr)]));
  };
  const handleOnBlurEventFields = (e, name) => {
    let localErr = errorMessagesFromRedux || [];
    if (e.target.value === '' || e.target.value === null) {
      localErr.push({
        fieldName: name,
        errorType: `${name}Required`,
        tabName: 'MainTab',
        message: constantMessageData.CONTRACT_REQUIRED,
      });
    } else {
      localErr = localErr?.filter((item) => item.fieldName !== name);
    }
    dispatch(
      maintainContractActions({
        ...maintainContractState,
        showSaveButton: 'Yes',
        [name]: e.target.value,
      })
    );
    localErr = localErr?.filter(
      (item) => item.message !== constantMessageData.CONTRACT_NO_CALCULATED_URA
    );
    dispatch(handleErrorMessages([...new Set(localErr)]));
  };
  const onChangeDateField = (d, name) => {
    setSuccessMessage([]);
    let localErr = errorMessagesFromRedux || [];
    if (d !== 'Invalid Date') {
      localErr = localErr?.filter((item) => item.fieldName !== name);
      dispatch(
        maintainContractActions({
          ...maintainContractState,
          showSaveButton: 'Yes',
          [name]: d,
        })
      );
    }
    localErr = localErr.filter(
      (e) => e.message !== constantMessageData.END_DATE_PROVIDED
    );
    localErr = localErr?.filter(
      (item) => item.message !== constantMessageData.CONTRACT_NO_CALCULATED_URA
    );
    dispatch(handleErrorMessages([...new Set(localErr)]));
  };
  // call on Blur event &OnChange even As of date filed level
  const handleOnBlurDateEvent = (d, name) => {
    setSuccessMessage([]);
    let localErr = errorMessagesFromRedux || [];
    if (d !== 'Invalid Date') {
      let value = null;
      if (d.target.value && d.target.value.length > 5) {
        const data = d.target.value.split('/');
        if (data[2].split('_').length === 3) {
          value = moment(d.target.value, 'MM/DD/YY').format('MM/DD/YYYY');
        } else {
          // eslint-disable-next-line prefer-destructuring
          value = d.target.value;
        }
      }
      if ((value === '' || value === null) && name === 'contractStartDate') {
        localErr = localErr?.filter((item) => item.fieldName !== name);
        localErr.push({
          fieldName: name,
          errorType: 'required',
          tabName: 'MainTab',
          message: constantMessageData.START_DATE_REQUIRED,
        });
      } else if (
        (value === '' || value === null) &&
        name === 'contractEndDate' &&
        ((searchContractState.contractType === 'onSelect' &&
          (getAllContractData?.planTypeCd == 'SUPP' ||
            getAllContractData?.planTypeCd == 'COMM')) ||
          (searchContractState.contractType === 'CreateContract' &&
            (searchContractState.createPlanType === 'SUPP' ||
              searchContractState.createPlanType === 'COMM')))
      ) {
        localErr = localErr?.filter((item) => item.fieldName !== name);
        localErr.push({
          fieldName: name,
          errorType: 'required',
          tabName: 'MainTab',
          message: constantMessageData.CONTRACT_END_DATE_REQ,
        });
      } else if (value && validDate(new Date(value)) === false) {
        localErr = localErr?.filter((item) => item.fieldName !== name);
        localErr.push({
          fieldName: name,
          errorType: 'InvalidDate',
          tabName: 'MainTab',
          message: constantMessageData.DATE_INVALID_FORMAT_ERROR,
        });
      } else if (name === 'contractStartDate') {
        if (
          value &&
          name === 'contractStartDate' &&
          compareTwoDatesGreaterThanOrEqual(value, moment(MinDate))
        ) {
          localErr = localErr?.filter((item) => item.fieldName !== name);
          localErr.push({
            fieldName: name,
            errorType: 'compareDateGreater',
            tabName: 'MainTab',
            message: constantMessageData.MINIMUM_START_ERROR_FOR_CONTRACT,
          });
        } else {
          localErr = localErr?.filter((item) => item.fieldName !== name);
        }
        if (
          maintainContractState?.contractEndDate &&
          compareTwoDatesGreaterThanOrEqual(
            maintainContractState?.contractEndDate,
            moment(value)
          )
        ) {
          localErr = localErr?.filter(
            (item) => item.fieldName !== 'contractEndDate'
          );
          localErr.push({
            fieldName: 'contractEndDate',
            errorType: 'compareDateGreater',
            tabName: 'MainTab',
            message:
              constantMessageData.END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
          });
        } else {
          localErr = localErr?.filter(
            (item) => item.fieldName !== 'contractEndDate'
          );
        }
      } else if (
        value &&
        name === 'contractEndDate' &&
        compareTwoDatesGreaterThanOrEqual(
          value,
          moment(
            maintainContractState.contractStartDate
              ? maintainContractState.contractStartDate
              : MinDate
          )
        )
      ) {
        localErr = localErr?.filter((item) => item.fieldName !== name);
        localErr.push({
          fieldName: name,
          errorType: 'compareDateGreater',
          tabName: 'MainTab',
          message:
            constantMessageData.END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
        });
      } else {
        localErr = localErr?.filter((item) => item.fieldName !== name);
      }
      localErr = localErr?.filter(
        (item) =>
          item.message !== constantMessageData.CONTRACT_NO_CALCULATED_URA
      );
      dispatch(
        maintainContractActions({
          ...maintainContractState,
          showSaveButton: 'Yes',
          [name]: value,
        })
      );
      dispatch(handleErrorMessages([...new Set(localErr)]));
    }
  };
  // go to particular manufacturer action button handler function
  const goToManufacturer = async () => {
    dispatch(setSelectManufacturerData({}));
    dispatch(fetchAllManufacturerDetail(null));
    dispatch(getContactDetails(null));
    // dispatch(getDisputeContactDetails(null));
    dispatch(maintainLabelerListData({}));
    dispatch(setMaintainManufacturerTab({}));
    const dataMfg = await dispatch(
      fetchAllManufacturerDetail({
        mfgId:
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.mfgId,
      })
    );
    const tempObj = {
      mfgId:
        getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.mfgId,
      mfgName:
        getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.mfgName,
      mfgTypeCd: dataMfg?.manufacturerDetailsList?.mfgVO?.mfgTypeCd || 'C',
    };
    tempObj.updateManufacturer = true;
    const result = await dispatch(setSelectManufacturerData(tempObj));
    if (result && Object.keys(result).length > 0) {
      redirectURLLink(
        '/manufacturer-detail',
        'Maintain Manufacturer',
        history,
        dispatch
      );
    }
  };
  const handleDuplicate = () => {
    setClickOncloseTabBtn(true);
    if (validateRequest()) {
      if (maintainContractState.contractEndDate == null) {
        const localErr = [];
        localErr.push({
          fieldName: 'endDte',
          errorType: 'endDteReq',
          tabName: 'MainTab',
          message: constantMessageData.END_DATE_PROVIDED,
        });
        dispatch(handleErrorMessages([...new Set(localErr)]));
      } else {
        setSuccessMessage([]);
        setDuplicatePopUp(true);
        setOpenDuplicatePop(true);
      }
    }
  };
  // handle save popup
  const openSave = (value) => {
    if (!value) {
      masterDataSave();
    } else {
      setIsSaveOpen(value);
      setIsCancelOpen(false);
    }
  };

  const validateRequest = () => {
    let errorMessage = errorMessagesFromRedux || [];
    if (
      maintainContractState?.contractName === '' ||
      maintainContractState?.contractName === null
    ) {
      errorMessage.push({
        fieldName: 'contractName',
        errorType: 'contractNameRequired',
        tabName: 'MainTab',
        message: constantMessageData.CONTRACT_REQUIRED,
      });
    }
    if (
      maintainContractState?.contractStartDate === '' ||
      maintainContractState?.contractStartDate === null
    ) {
      errorMessage.push({
        fieldName: 'contractStartDate',
        errorType: 'required',
        tabName: 'MainTab',
        message: constantMessageData.START_DATE_REQUIRED,
      });
    }
    if (
      ((searchContractState.contractType === 'onSelect' &&
        (getAllContractData?.planTypeCd == 'SUPP' ||
          getAllContractData?.planTypeCd == 'COMM')) ||
        (searchContractState.contractType === 'CreateContract' &&
          (searchContractState.createPlanType === 'SUPP' ||
            searchContractState.createPlanType === 'COMM'))) &&
      (maintainContractState?.contractEndDate === '' ||
        maintainContractState?.contractEndDate === null)
    ) {
      errorMessage.push({
        fieldName: 'contractEndDate',
        errorType: 'required',
        tabName: 'MainTab',
        message: constantMessageData.CONTRACT_END_DATE_REQ,
      });
    }
    // invoice contact tab error
    // if (invoiceContact?.manufacturerID === '' || invoiceContact?.manufacturerID === null) {
    //   errorMessage.push({
    //     fieldName: 'manufacturerID',
    //     errorType: 'manufacturerIDRequired',
    //     tabName: 'InvoiceContact',
    //     message: `${constantMessageData.MFG_ID_FOR_CONTRACT} for invoice contact.`,
    //     subMessage: `${constantMessageData.MFG_ID_FOR_CONTRACT}.`,

    //   });
    // }
    // if (invoiceContact?.manufacturerName === '' || invoiceContact?.manufacturerName === null) {
    //   errorMessage.push({
    //     fieldName: 'manufacturerName',
    //     errorType: 'manufacturerNameRequired',
    //     tabName: 'InvoiceContact',
    //     message: `${constantMessageData.MFG_NAME_FOR_CONTRACT} for invoice contact.`,
    //     subMessage: `${constantMessageData.MFG_NAME_FOR_CONTRACT}.`,

    //   });
    // }
    // if (invoiceContact?.contactTypeCode === '' || invoiceContact?.contactTypeCode === null) {
    //   errorMessage.push({
    //     fieldName: 'contactTypeCode',
    //     errorType: 'contactTypeCodeRequired',
    //     tabName: 'InvoiceContact',
    //     message: `${constantMessageData.CONTACT_TYPE_CODE_FOR_CONTRACT} for invoice contact.`,
    //     subMessage: `${constantMessageData.CONTACT_TYPE_CODE_FOR_CONTRACT}.`,

    //   });
    // }
    // if (invoiceContact?.description === '' || invoiceContact?.description === null) {
    //   errorMessage.push({
    //     fieldName: 'description',
    //     errorType: 'descriptionRequired',
    //     tabName: 'InvoiceContact',
    //     message: `${constantMessageData.DESCRIPTION_FOR_CONTRACT} for invoice contact.`,
    //     subMessage: `${constantMessageData.DESCRIPTION_FOR_CONTRACT}.`,
    //   });
    // }
    if (
      invoiceContact?.email &&
      invoiceContact?.email !== '' &&
      !Constants.EMAIL_ID_REGEX.test(invoiceContact?.email)
    ) {
      errorMessage = errorMessage?.filter((item) => item.fieldName !== 'email');
      errorMessage.push({
        fieldName: 'email',
        errorType: 'emailInvalid',
        tabName: 'InvoiceContact',
        message: constantMessageData.EMAIL_INVALID_FOR_INVOICE_CONTRACT_TAB,
        subMessage: constantMessageData.EMAIL_INVALID,
      });
    }
    if (
      invoiceContact?.zip4 &&
      invoiceContact?.zip4 !== '' &&
      invoiceContact?.zip4.length <= 3
    ) {
      errorMessage.push({
        fieldName: 'zip4',
        errorType: 'zipRequired',
        tabName: 'InvoiceContact',
        message: constantMessageData.ZIP4_REQUIRED_FOR_INVOICE_CONTRACT_TAB,
        subMessage: constantMessageData.ZIP4_REQUIRED,
      });
    }
    if (
      invoiceContact?.phoneNum &&
      invoiceContact?.phoneNum !== '' &&
      invoiceContact?.phoneNum.length <= 9
    ) {
      errorMessage.push({
        fieldName: 'phoneNum',
        errorType: 'InvalidPhone',
        tabName: 'InvoiceContact',
        message:
          constantMessageData.PHONE_INVALID_ERROR_FOR_INVOICE_CONTRACT_TAB,
        subMessage: constantMessageData.PHONE_INVALID_ERROR,
      });
    }
    // dispute contact tab error
    // if (disputeContract?.manufacturerID === '' || disputeContract?.manufacturerID === null) {
    //   errorMessage.push({
    //     fieldName: 'manufacturerID',
    //     errorType: 'manufacturerIDRequired',
    //     tabName: 'DisputeContact',
    //     message: `${constantMessageData.MFG_ID_FOR_CONTRACT} for dispute contact.`,
    //     subMessage: `${constantMessageData.MFG_ID_FOR_CONTRACT}.`,

    //   });
    // }
    // if (disputeContract?.manufacturerName === '' || disputeContract?.manufacturerName === null) {
    //   errorMessage.push({
    //     fieldName: 'manufacturerName',
    //     errorType: 'manufacturerNameRequired',
    //     tabName: 'DisputeContact',
    //     message: `${constantMessageData.MFG_NAME_FOR_CONTRACT} for dispute contact.`,
    //     subMessage: `${constantMessageData.MFG_NAME_FOR_CONTRACT}.`,

    //   });
    // }
    // if (disputeContract?.contactTypeCode === '' || disputeContract?.contactTypeCode === null) {
    //   errorMessage.push({
    //     fieldName: 'contactTypeCode',
    //     errorType: 'contactTypeCodeRequired',
    //     tabName: 'DisputeContact',
    //     message: `${constantMessageData.CONTACT_TYPE_CODE_FOR_CONTRACT} for dispute contact.`,
    //     subMessage: `${constantMessageData.CONTACT_TYPE_CODE_FOR_CONTRACT}.`,

    //   });
    // }
    // if (disputeContract?.description === '' || disputeContract?.description === null) {
    //   errorMessage.push({
    //     fieldName: 'description',
    //     errorType: 'descriptionRequired',
    //     tabName: 'DisputeContact',
    //     message: `${constantMessageData.DESCRIPTION_FOR_CONTRACT} for dispute contact.`,
    //     subMessage: `${constantMessageData.DESCRIPTION_FOR_CONTRACT}.`,
    //   });
    // }
    if (
      disputeContract?.email &&
      disputeContract?.email !== '' &&
      !Constants.EMAIL_ID_REGEX.test(disputeContract?.email)
    ) {
      errorMessage.push({
        fieldName: 'email',
        errorType: 'emailInvalid',
        tabName: 'DisputeContact',
        message: constantMessageData.EMAIL_INVALID_FOR_DISPUTE_CONTRACT_TAB,
        subMessage: constantMessageData.EMAIL_INVALID,
      });
    }
    if (
      disputeContract?.zip4 &&
      disputeContract?.zip4 !== '' &&
      disputeContract?.zip4.length <= 3
    ) {
      errorMessage.push({
        fieldName: 'zip4',
        errorType: 'zipRequired',
        tabName: 'DisputeContact',
        message: constantMessageData.ZIP4_REQUIRED_FOR_DISPUTE_CONTRACT_TAB,
        subMessage: constantMessageData.ZIP4_REQUIRED,
      });
    }
    if (
      disputeContract?.phoneNum &&
      disputeContract?.phoneNum !== '' &&
      disputeContract?.phoneNum.length <= 9
    ) {
      errorMessage.push({
        fieldName: 'phoneNum',
        errorType: 'InvalidPhone',
        tabName: 'DisputeContact',
        message:
          constantMessageData.PHONE_INVALID_ERROR_FOR_DISPUTE_CONTRACT_TAB,
        subMessage: constantMessageData.PHONE_INVALID_ERROR,
      });
    }
    errorMessage = errorMessage?.filter(
      (item) => item.message !== constantMessageData.CONTRACT_NO_CALCULATED_URA
    );
    dispatch(handleErrorMessages([...new Set(errorMessage)]));
    if (errorMessage?.length > 0) {
      return false;
    }
    if (errorMessage?.length === 0) {
      setSuccessMessage([]);
      dispatch(handleErrorMessages([]));
      return true;
    }
  };
  const masterDataSave = () => {
    let fDate = null;
    let rebProg = '';
    let drugPrice = false;
    let toDate = null;
    if (duplicateAction) {
      fDate = formValue.fromDate == null ? null : formValue.fromDate;
      toDate = formValue.toDate == null ? null : formValue.toDate;
      rebProg = formValue.rebateProgramCode;
      drugPrice = drugPrice ? 1 : 0;
    } else {
      fDate =
        maintainContractState.contractStartDate == null
          ? null
          : maintainContractState.contractStartDate;
      toDate =
        maintainContractState.contractEndDate == null
          ? null
          : maintainContractState.contractEndDate;
      rebProg = formValue.rebateProgramCode;
      drugPrice = drugPrice ? 1 : 0;
    }
    const fromDate =
      fDate == null ? null : moment(fDate).format('MM/DD/YYYY 00:00');
    const endDate =
      toDate == null ? null : moment(toDate).format('MM/DD/YYYY 00:00');
    const newData = {};
    newData.coverageGapRequest = [];
    getCoverageTable &&
      getCoverageTable.map((item) => {
        const data = {};
        if (item.startDate !== null) {
          data.addedDate =
            searchContractState.contractType === 'onSelect'
              ? ''
              : `${currDate} 00:00`;
          data.addedUserId =
            searchContractState.contractType === 'onSelect' ? '' : logInUser;
          data.contractSeqNumber = duplicateAction
            ? newContractSeqNum
            : searchContractState.contractType === 'onSelect'
            ? getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                .contractSeqNum
            : maintainContractState.contractSeqNum;
          data.endDate =
            item.endDate == null || item.endDate == ''
              ? null
              : moment(item.endDate).format('MM/DD/yyyy 00:00');
          data.lastUpdateUserId =
            searchContractState.contractType === 'onSelect' ? logInUser : '';
          data.mfgId =
            searchContractState.contractType === 'onSelect'
              ? getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                  .mfgId
              : searchContractState.selectedRowData;
          data.rebateProgramCd =
            searchContractState.contractType === 'onSelect'
              ? getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                  .rebateProgramCd
              : searchContractState.createRebateProgramCode;
          data.startDate =
            item.startDate == null || item.startDate == ''
              ? null
              : moment(item.startDate).format('MM/DD/yyyy 00:00');
          newData.coverageGapRequest.push(data);
        }
      });
    newData.deletedCoverageArr = [];
    newData.deleteCoverageGapRequest = [];
    if (
      searchContractState.contractType === 'onSelect' &&
      duplicateAction == false
    ) {
      deleteCoverageGap &&
        deleteCoverageGap.map((item) => {
          const data = {};
          getAllContractData.coverageGap &&
            getAllContractData.coverageGap.map((i, index) => {
              if (item.indexKey == index) {
                if (i.startDate !== null) {
                  data.addedDate = i.addedDate;
                  data.addedUserId = i.addedUserId;
                  data.contractSeqNumber = i.contractSeqNumber;
                  data.endDate =
                    i.endDate == null || i.endDate == ''
                      ? null
                      : moment(i.endDate).format('MM/DD/YYYY 00:00');
                  data.lastUpdateUserId = i.lastUpdateUserId;
                  data.mfgId = i.mfgId;
                  data.rebateProgramCd = i.rebateProgramCd;
                  data.startDate =
                    i.startDate == null || i.startDate == ''
                      ? null
                      : moment(i.startDate).format('MM/DD/YYYY 00:00');
                  newData.deletedCoverageArr.push(data);
                }
              }
            });
        });
    }
    newData.deleteCoverageGapRequest = [...new Set(newData.deletedCoverageArr)];
    // Send empty contact payloads when that contact tab has no changes.
    if (
      originalDisputeContactRef.current &&
      isContractContactUnchanged(
        maintainContractState.disputeContract,
        originalDisputeContactRef.current
      )
    ) {
      newData.disputeContactRequest = {};
    } else {
      newData.disputeContactRequest = maintainContractState.disputeContract;
      if (Object.keys(newData.disputeContactRequest || {})?.length > 0) {
        newData.disputeContactRequest = {
          ...newData.disputeContactRequest,
          key:
            searchContractState.contractType === 'onSelect'
              ? maintainContractState?.mfgId
              : searchContractState?.selectedRowData,
        };
      }
    }
    if (
      originalInvoiceContactRef.current &&
      isContractContactUnchanged(
        maintainContractState.invoiceContact,
        originalInvoiceContactRef.current
      )
    ) {
      newData.invoiceContactRequest = {};
    } else {
      newData.invoiceContactRequest = maintainContractState.invoiceContact;
      if (Object.keys(newData.invoiceContactRequest || {})?.length > 0) {
        newData.invoiceContactRequest = {
          ...newData.invoiceContactRequest,
          key:
            searchContractState.contractType === 'onSelect'
              ? maintainContractState?.mfgId
              : searchContractState?.selectedRowData,
        };
      }
    }
    newData.otherContactRequest = [];
    if (
      !(
        originalListOfOtherContactRef.current &&
        isOtherContactListUnchanged(
          maintainContractState.listOfOtherContact,
          originalListOfOtherContactRef.current
        )
      )
    ) {
      const otherConReq =
        maintainContractState.listOfOtherContact &&
        maintainContractState.listOfOtherContact.map((item) => {
          if (item.contactTypeCd && item.contactName) {
            newData.otherContactRequest.push(item);
          }
          return item;
        });
    }
    newData.drugFamilyGridRequest = [];
    getDrugFamilyTable &&
      getDrugFamilyTable.map((item) => {
        const drugFamily = {};
        drugFamily.drugfamilyname = item.drugfamilyname;
        drugFamily.startQtr =
          item.startquarter == '' ? null : item.startquarter;
        drugFamily.endQtr = item.endquarter == '' ? null : item.endquarter;
        drugFamily.rebatePricingMethodCd =
          item.REBATE_PRICING_METHOD_CD != '-1'
            ? item.REBATE_PRICING_METHOD_CD
            : null;
        drugFamily.volumeCalcMethodCd =
          item.VOLUME_CALC_METHOD_CD !== '-1'
            ? item.VOLUME_CALC_METHOD_CD
            : null;
        drugFamily.mktShareCalcMethodCd =
          item.MKT_SHARE_CALC_METHOD_CD !== '-1'
            ? item.MKT_SHARE_CALC_METHOD_CD
            : null;
        drugFamily.basketname =
          item.basketname !== '-1' ? item.basketname : null;
        drugFamily.natMktShareTypeCd =
          item.NAT_MKT_SHARE_TYPE_CD !== '-1'
            ? item.NAT_MKT_SHARE_TYPE_CD
            : null;
        drugFamily.sharegroup = item.sharegroup;
        drugFamily.subgroupId = item.subgroupid;
        drugFamily.corrLinkId =
          item.corrLinkId == null || item.corrLinkId == ''
            ? ''
            : item.corrLinkId;
        drugFamily.action = '';
        drugFamily.addedDate =
          searchContractState.contractType === 'onSelect'
            ? ''
            : `${currDate} 00:00`;
        drugFamily.addedUserId =
          searchContractState.contractType === 'onSelect' ? '' : logInUser;
        drugFamily.contractSeqNum = duplicateAction
          ? newContractSeqNum
          : searchContractState.contractType === 'onSelect'
          ? getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
              .contractSeqNum
          : maintainContractState.contractSeqNum;
        drugFamily.lastUpdateUserId =
          searchContractState.contractType === 'onSelect' ? logInUser : '';
        drugFamily.lastUpdateDt =
          searchContractState.contractType === 'onSelect'
            ? `${currDate} 00:00`
            : '';
        drugFamily.contractFamilySeqNum = item.contractFamilySeqNum || null;
        drugFamily.familySeqNum = item.familySeqNum || null;
        drugFamily.marketBasketSeqNum = item.marketBasketSeqNum || null;
        drugFamily.marketShareId = item.marketShareId || null;
        newData.drugFamilyGridRequest.push(drugFamily);
        return drugFamily;
      });
    newData.deleteDrugFamilyGridRequest = [];
    if (
      searchContractState.contractType === 'onSelect' &&
      duplicateAction == false
    ) {
      deleteDrugFamily &&
        deleteDrugFamily.map((item) => {
          const drugFamily = {};
          drugFamily.drugfamilyname = item.drugfamilyname;
          drugFamily.startQtr =
            item.startquarter == '' ? null : item.startquarter;
          drugFamily.endQtr = item.endquarter == '' ? null : item.endquarter;
          drugFamily.rebatePricingMethodCd =
            item.REBATE_PRICING_METHOD_CD != '-1'
              ? item.REBATE_PRICING_METHOD_CD
              : null;
          drugFamily.volumeCalcMethodCd =
            item.VOLUME_CALC_METHOD_CD !== '-1'
              ? item.VOLUME_CALC_METHOD_CD
              : null;
          drugFamily.mktShareCalcMethodCd =
            item.MKT_SHARE_CALC_METHOD_CD !== '-1'
              ? item.MKT_SHARE_CALC_METHOD_CD
              : null;
          drugFamily.basketname =
            item.basketname !== '-1' ? item.basketname : null;
          drugFamily.natMktShareTypeCd =
            item.NAT_MKT_SHARE_TYPE_CD !== '-1'
              ? item.NAT_MKT_SHARE_TYPE_CD
              : null;
          drugFamily.sharegroup = item.sharegroup;
          drugFamily.subgroupId = item.subgroupid;
          drugFamily.corrLinkId =
            item.corrLinkId == null || item.corrLinkId == ''
              ? ''
              : item.corrLinkId;
          drugFamily.action = '';
          drugFamily.addedDate =
            searchContractState.contractType === 'onSelect'
              ? ''
              : `${currDate} 00:00`;
          drugFamily.addedUserId =
            searchContractState.contractType === 'onSelect' ? '' : logInUser;
          drugFamily.contractSeqNum = duplicateAction
            ? newContractSeqNum
            : searchContractState.contractType === 'onSelect'
            ? getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                .contractSeqNum
            : maintainContractState.contractSeqNum;
          drugFamily.lastUpdateUserId =
            searchContractState.contractType === 'onSelect' ? logInUser : '';
          drugFamily.lastUpdateDt =
            searchContractState.contractType === 'onSelect'
              ? `${currDate} 00:00`
              : '';
          drugFamily.contractFamilySeqNum = item.contractFamilySeqNum || null;
          drugFamily.familySeqNum = item.familySeqNum || null;
          drugFamily.marketBasketSeqNum = item.marketBasketSeqNum || null;
          drugFamily.marketShareId = item.marketShareId || null;
          newData.deleteDrugFamilyGridRequest.push(drugFamily);
          return drugFamily;
        });
    }
    newData.headerCalcMfgAndDetailsTabRequest = {};
    newData.headerCalcMfgAndDetailsTabRequest.calcInnovSinglePct =
      calTab.calcInnovSinglePct;
    newData.headerCalcMfgAndDetailsTabRequest.calcNonInnovPct =
      calTab.calcNonInnovPct;
    newData.headerCalcMfgAndDetailsTabRequest.cmsElectFinalQtr =
      manufacturerTab.cmsElectFinalQtr || null;
    newData.headerCalcMfgAndDetailsTabRequest.cmsElectInd =
      manufacturerTab.cmsElectInd;
    newData.headerCalcMfgAndDetailsTabRequest.cmsNdcInclInd =
      calTab.cmsNdcInclInd == true ? 1 : 0;
    newData.headerCalcMfgAndDetailsTabRequest.collectionMediumCd =
      manufacturerTab.collectionMediumCd !== '-1'
        ? manufacturerTab.collectionMediumCd
        : null;
    newData.headerCalcMfgAndDetailsTabRequest.contractCalcMethodCd =
      calTab.contractCalcMethodCd !== '-1' ? calTab.contractCalcMethodCd : '';
    newData.headerCalcMfgAndDetailsTabRequest.contractDefDispSpecialist =
      detailTab.disputeSpecialists != '-1'
        ? detailTab.disputeSpecialists
        : null;
    newData.headerCalcMfgAndDetailsTabRequest.contractName =
      maintainContractState?.contractName;
    newData.headerCalcMfgAndDetailsTabRequest.contractSeqNum = duplicateAction
      ? newContractSeqNum
      : searchContractState.contractType === 'onSelect'
      ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
          ?.contractSeqNum
      : maintainContractState.contractSeqNum;
    newData.headerCalcMfgAndDetailsTabRequest.contractValidInd = duplicateAction
      ? 0
      : searchContractState.contractType === 'onSelect'
      ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
          ?.contractValidInd
      : 0;
    newData.headerCalcMfgAndDetailsTabRequest.corrLinkId = duplicateAction
      ? ''
      : searchContractState.contractType === 'onSelect'
      ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.corrLinkId
      : null;
    newData.headerCalcMfgAndDetailsTabRequest.detailLevelOnInvoiceCd =
      detailTab.detailInvoices != '-1' ? detailTab.detailInvoices : null;
    newData.headerCalcMfgAndDetailsTabRequest.dispContactSeqNum =
      disputeContract.contactSeqNum;
    newData.headerCalcMfgAndDetailsTabRequest.earliestQtrForDrugDetails =
      detailTab.earliestQuarter || null;
    newData.headerCalcMfgAndDetailsTabRequest.endDt = endDate;
    newData.headerCalcMfgAndDetailsTabRequest.enrollmentTimingCd =
      manufacturerTab.enrollmentTimingCd !== '-1'
        ? manufacturerTab.enrollmentTimingCd
        : null;
    newData.headerCalcMfgAndDetailsTabRequest.invContactSeqNum =
      invoiceContact.contactSeqNum;
    newData.headerCalcMfgAndDetailsTabRequest.lastUpdateDt = `${currDate} 00:00`;
    newData.headerCalcMfgAndDetailsTabRequest.lastUpdateUserId = logInUser;
    newData.headerCalcMfgAndDetailsTabRequest.letterSenderUserId =
      detailTab.letterSender !== '-1' ? detailTab.letterSender : null;
    newData.headerCalcMfgAndDetailsTabRequest.mfgId =
      searchContractState.contractType === 'onSelect'
        ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.mfgId
        : searchContractState?.selectedRowData;
    newData.headerCalcMfgAndDetailsTabRequest.ncpdpClaimMbFinalQtr =
      manufacturerTab.ncpdpClaimMbFinalQtr || null;
    newData.headerCalcMfgAndDetailsTabRequest.ncpdpClaimMbInd =
      manufacturerTab.ncpdpClaimMbInd;
    newData.headerCalcMfgAndDetailsTabRequest.ncpdpClaimOwnFinalQtr =
      manufacturerTab.ncpdpClaimOwnFinalQtr || null;
    newData.headerCalcMfgAndDetailsTabRequest.ncpdpClaimOwnInd =
      manufacturerTab.ncpdpClaimOwnInd;
    newData.headerCalcMfgAndDetailsTabRequest.ncpdpSummaryFinalQtr =
      manufacturerTab.ncpdpSummaryFinalQtr || null;
    newData.headerCalcMfgAndDetailsTabRequest.ncpdpSummaryInd =
      manufacturerTab.ncpdpSummaryInd;
    newData.headerCalcMfgAndDetailsTabRequest.nonCmsNdcInclInd =
      calTab.cmsNdcInclInd == true ? 1 : 0;
    newData.headerCalcMfgAndDetailsTabRequest.paperFinalQtr =
      manufacturerTab.paperFinalQtr || null;
    newData.headerCalcMfgAndDetailsTabRequest.paperInd =
      manufacturerTab.paperInd;
    newData.headerCalcMfgAndDetailsTabRequest.pricingTimingCd =
      manufacturerTab.pricingTimingCd !== '-1'
        ? manufacturerTab.pricingTimingCd
        : null;
    newData.headerCalcMfgAndDetailsTabRequest.printImageFinalQtr =
      manufacturerTab.printImageFinalQtr || null;
    newData.headerCalcMfgAndDetailsTabRequest.printImageInd =
      manufacturerTab.printImageInd;
    newData.headerCalcMfgAndDetailsTabRequest.rebateProgramCd = duplicateAction
      ? formValue.rebateProgramCode
      : searchContractState.contractType === 'onSelect'
      ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
          ?.rebateProgramCd
      : searchContractState?.createRebateProgramCode;
    newData.headerCalcMfgAndDetailsTabRequest.sendToCommercialMfgInd =
      detailTab.sendToCommercialMfgInd == true ? 1 : 0;
    newData.headerCalcMfgAndDetailsTabRequest.startDt = fromDate;
    newData.headerCalcMfgAndDetailsTabRequest.useDefMfgInd =
      manufacturerTab.useDefMfgInd;
    newData.headerCalcMfgAndDetailsTabRequest.useDefRpcInd =
      detailTab.useDefRpcInd == true ? 1 : 0;
    newData.headerCalcMfgAndDetailsTabRequest.writeOffDt =
      detailTab.writeOffDate != null
        ? moment(detailTab.writeOffDate).format('MM/DD/YYYY 00:00')
        : null;
    dispatch(dispatchInitialResponse(true));
    dispatch(getCreateAndUpdateContract(newData));
  };
  // call after check all validation
  const onSubmit = (value) => {
    setClickOncloseTabBtn(value);
    if (validateRequest()) {
      dispatch(handleErrorMessages([]));
      setSuccessMessage([]);
      openSave(value);
    } else {
      handleScrollToEvent();
    }
  };
  const handleValidateContract = () => {
    setCallValidateContract(true);
    setClickOncloseTabBtn(true);
    // onSaveButtonClick()
    setCreateValidate(false);
    masterDataSave();
  };
  // handing view History popup
  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({
      CONTRACT_SEQ_NUM:
        getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
          .contractSeqNum,
    });
  };
  const resetInitialField = () => {
    dispatch(
      maintainContractActions({
        rebateProgramCd: '',
        mfgId: '',
        mfgName: '',
        shortDescr: '',
        contractSeqNum: '',
        contractName: '',
        contractStartDate: null,
        contractEndDate: null,
        errorContractName: false,
        errorStartDate: false,
        errorEndDate: false,
        errorInvalidStartDate: false,
        errorInvalidEndDate: false,
        corrLinkId: null,
        showSaveButton: 'No',
        disableDrugFamilyTab: true,
        disableCoverageTab: false,
        disableCalTab: false,
        tabValue: 'one',
        calTab: {
          cmsNdcInclInd: false,
          nonCmsNdcInclInd: false,
          contractCalcMethodCd: '-1',
          calcNonInnovPct: '',
          calcInnovSinglePct: '',
        },
        detailTab: {
          detailInvoices: '-1',
          disputeSpecialists: '-1',
          letterSender: '-1',
          earliestQuarter: '',
          errorInvalidQuarter: false,
          sendToCommercialMfgInd: false,
          useDefRpcInd: false,
          writeOffDate: null,
          writeOffDatePop: null,
          errorInvalidWirteOffDate: false,
          errorInvalidWirteOffDatePop: false,
        },
        manufacturerTab: {
          paperFinalQtr: null,
          printImageFinalQtr: null,
          cmsElectFinalQtr: null,
          ncpdpSummaryFinalQtr: null,
          ncpdpClaimOwnFinalQtr: null,
          ncpdpClaimMbFinalQtr: null,
          useDefMfgInd: 0,
          useDefRpcInd: 0,
          paperInd: 0,
          printImageInd: 0,
          cmsElectInd: 0,
          ncpdpSummaryInd: 0,
          ncpdpClaimOwnInd: 0,
          ncpdpClaimMbInd: 0,
          sendToCommercialMfgInd: 0,
          contractValidInd: 0,
          pricingTimingCd: '-1',
          enrollmentTimingCd: '-1',
          detailLevelOnInvoiceCd: null,
          collectionMediumCd: '-1',
          contractDefDispSpecialist: null,
          letterSenderUserId: null,
          invContactSeqNum: null,
          dispContactSeqNum: null,
          writeOffDt: null,
        },
        invoiceContact: {
          manufacturerID: '',
          manufacturerName: '',
          contactTypeCode: '',
          description: '',
          contactName: '',
          corpName: '',
          addrLine1: '',
          addrLine2: '',
          addrLine3: '',
          city: '',
          stateCd: '',
          zip: '',
          zip4: '',
          phoneNum: '',
          phoneExtension: '',
          faxNum: '',
          email: '',
        },
        disputeContract: {
          manufacturerID: '',
          manufacturerName: '',
          contactTypeCode: '',
          description: '',
          contactName: '',
          corpName: '',
          addrLine1: '',
          addrLine2: '',
          addrLine3: '',
          city: '',
          stateCd: '',
          zip: '',
          zip4: '',
          phoneNum: '',
          phoneExtension: '',
          faxNum: '',
          email: '',
        },
        errordisputeContract: {
          manufacturerID: '',
          manufacturerName: '',
          contactTypeCode: '',
          description: '',
          invalidPhoneNum: false,
          invalidEmail: false,
        },
        getAllOtherContract: [],
        listOfOtherContact: [],
        otherContract: {
          contactTypeCd: 'CTR1',
          contactName: '',
          corpName: '',
          addrLine1: '',
          addrLine2: '',
          addrLine3: '',
          city: '',
          stateCd: '',
          zip: '',
          zip4: '',
          phoneNum: '',
          phoneExtension: '',
          faxNum: '',
          email: '',
        },
        errorOtherContract: {
          contactName: false,
          corpName: false,
          addrLine1: false,
          city: false,
          stateCd: false,
          zip: false,
          phoneNum: false,
          email: false,
          invalidPhoneNum: false,
          invalidEmail: false,
        },
        drugFamily: {
          drugFamilyQtr: '',
          errorInvalidQuarter: false,
          selectedDrugFamilyAddRow: {},
        },
      })
    );
  };
  // after getting the data from get service call
  React.useEffect(() => {
    if (
      getAllContractData &&
      Object.keys(getAllContractData).length > 0 &&
      getAllContractData?.error == null &&
      initialResponse
    ) {
      // dispatch(getPlanTypeDesc(searchContractState.planType));
      dispatch(handleErrorMessages([]));
      setLoading(false);
      dispatch(dispatchInitialResponse(false));
      const coverageGap = getAllContractData?.coverageGap
        ? JSON.parse(JSON.stringify(getAllContractData.coverageGap))
        : [];
      const coverageGap1 = getAllContractData?.coverageGap
        ? JSON.parse(JSON.stringify(getAllContractData.coverageGap))
        : [];
      dispatch(dispatchCoverageTable(coverageGap, '', '', 'onLoad'));
      dispatch(dispatchInitialCoverageGap(coverageGap1));
      const data = otherContract;
      const headerData = {};
      if (getDataAfterSave == false) {
        headerData.disableDrugFamilyTab =
          getAllContractData.planTypeCd == 'SUPP'
            ? false
            : getAllContractData.planTypeCd != 'COMM';
        headerData.disableCalTab = getAllContractData.planTypeCd == 'FD';
        headerData.disableCoverageTab = getAllContractData.planTypeCd != 'ST';
        if (headerData.disableDrugFamilyTab && headerData.disableCalTab) {
          dispatch(dispatchTabValue('three'));
        } else if (headerData.disableDrugFamilyTab)
          dispatch(dispatchTabValue('two'));
        else dispatch(dispatchTabValue('one'));
      }
      headerData.contractName =
        searchContractState.contractType === 'onSelect'
          ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
              ?.contractName
          : maintainContractState?.contractName;
      headerData.rebateProgramCd =
        searchContractState.contractType === 'onSelect'
          ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
              ?.rebateProgramCd
          : maintainContractState?.rebateProgramCd;
      headerData.mfgName =
        searchContractState.contractType === 'onSelect'
          ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
              ?.mfgName
          : '';
      headerData.shortDescr =
        searchContractState.contractType === 'onSelect'
          ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
              ?.shortDescr
          : maintainContractState?.shortDescr;
      headerData.mfgId =
        searchContractState.contractType === 'onSelect'
          ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.mfgId
          : maintainContractState?.mfgId;
      headerData.contractSeqNum =
        getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
          ?.contractSeqNum || '';
      headerData.contractStartDate =
        searchContractState.contractType === 'onSelect'
          ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
              ?.startDt
            ? new Date(
                getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab.startDt
              )
            : null
          : maintainContractState.contractStartDate;
      headerData.contractEndDate =
        searchContractState.contractType === 'onSelect'
          ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.endDt
            ? moment(
                new Date(
                  getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab.endDt
                )
              ).format('MM/DD/YYYY')
            : null
          : maintainContractState.contractEndDate;
      headerData.showSaveButton = 'No';
      const noOfOtherContacts = [];
      const otherCon = getContactType.map((item, index) => {
        const data = {};
        data.contactTypeCd = item.contactTypeCd;
        data.contactName = '';
        data.corpName = '';
        data.addrLine1 = '';
        data.addrLine2 = '';
        data.addrLine3 = '';
        data.city = '';
        data.stateCd = '';
        data.zip = '';
        data.zip4 = '';
        data.phoneNum = '';
        data.phoneExtension = '';
        data.faxNum = '';
        data.email = '';
        data.addressChangedInd = null;
        data.contactSeqNum = null;
        data.copySourceSeqNum = null;
        data.corrLinkId = null;
        data.key =
          searchContractState.contractType === 'onSelect'
            ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                ?.contractSeqNum
            : maintainContractState?.contractSeqNum;
        data.keyTypeCd = 'CONTRACT';
        data.lastUpdateDT = `${currDate} 00:00`;
        data.lastUpdateUserID = logInUser;
        data.nameChangedInd = null;
        data.needsAttentionCd = null;
        noOfOtherContacts.push(data);
      });
      if (
        getAllContractData &&
        Object.keys(getAllContractData).length > 0 &&
        getAllContractData?.otherContactTab &&
        getAllContractData.otherContactTab.length > 0
      ) {
        data.contactTypeCd =
          getAllContractData?.otherContactTab[0].contactTypeCd || 'CTR1';
        data.contactName =
          getAllContractData?.otherContactTab[0].contactName || '';
        data.corpName = getAllContractData?.otherContactTab[0].corpName || '';
        data.addrLine1 = getAllContractData?.otherContactTab[0].addrLine1 || '';
        data.addrLine2 = getAllContractData?.otherContactTab[0].addrLine2 || '';
        data.addrLine3 = getAllContractData?.otherContactTab[0].addrLine3 || '';
        data.city = getAllContractData?.otherContactTab[0].city || '';
        data.stateCd = getAllContractData?.otherContactTab[0].stateCd || '';
        data.zip = getAllContractData?.otherContactTab[0].zip || '';
        data.zip4 = getAllContractData?.otherContactTab[0].zip4 || '';
        data.phoneNum = getAllContractData?.otherContactTab[0].phoneNum || '';
        data.phoneExtension =
          getAllContractData?.otherContactTab[0].phoneExtension || '';
        data.faxNum = getAllContractData?.otherContactTab[0].faxNum || '';
        data.email = getAllContractData?.otherContactTab[0].email || '';
        data.corrLinkId =
          getAllContractData?.otherContactTab[0].corrLinkId || null;
        noOfOtherContacts.map((data) => {
          getAllContractData &&
            getAllContractData.otherContactTab.map((item) => {
              if (item.contactTypeCd == data.contactTypeCd) {
                data.contactTypeCd = item.contactTypeCd;
                data.contactName = item.contactName;
                data.corpName = item.corpName;
                data.addrLine1 = item.addrLine1;
                data.addrLine2 = item.addrLine2;
                data.addrLine3 = item.addrLine3;
                data.city = item.city;
                data.stateCd = item.stateCd;
                data.zip = item.zip;
                data.zip4 = item.zip4;
                data.phoneNum = item.phoneNum;
                data.phoneExtension = item.phoneExtension;
                data.faxNum = item.faxNum;
                data.email = item.email;
                data.corrLinkId = item.corrLinkId;
                data.contactSeqNum = item.contactSeqNum;
              }
              return data;
            });
        });
      }
      const disputeData = {};
      if (
        getAllContractData &&
        Object.keys(getAllContractData).length > 0 &&
        getAllContractData?.disputeContactTab !== null &&
        Object.keys(getAllContractData?.disputeContactTab).length > 0
      ) {
        // disputeData = { ...disputeContract };
        disputeData.manufacturerID =
          getAllContractData?.disputeContactTab?.mfgId || '';
        disputeData.manufacturerName =
          getAllContractData?.disputeContactTab?.mfgName || '';
        disputeData.contactTypeCode =
          getAllContractData?.disputeContactTab?.contactTypeCd || '';
        disputeData.description =
          getAllContractData?.disputeContactTab?.shortDescr || '';
        disputeData.contactName =
          getAllContractData?.disputeContactTab?.contactName || '';
        disputeData.corpName =
          getAllContractData?.disputeContactTab?.corpName || '';
        disputeData.addrLine1 =
          getAllContractData?.disputeContactTab?.addrLine1 || '';
        disputeData.addrLine2 =
          getAllContractData?.disputeContactTab?.addrLine2 || '';
        disputeData.addrLine3 =
          getAllContractData?.disputeContactTab.addrLine3 || '';
        disputeData.city = getAllContractData?.disputeContactTab?.city || '';
        disputeData.stateCd =
          getAllContractData?.disputeContactTab.stateCd || '';
        disputeData.zip = getAllContractData?.disputeContactTab.zip || '';
        disputeData.zip4 = getAllContractData?.disputeContactTab.zip4 || '';
        disputeData.phoneNum =
          getAllContractData?.disputeContactTab.phoneNum || '';
        disputeData.phoneExtension =
          getAllContractData?.disputeContactTab.phoneExtension || '';
        disputeData.faxNum = getAllContractData?.disputeContactTab.faxNum || '';
        disputeData.email = getAllContractData?.disputeContactTab.email || '';
        disputeData.addressChangedInd =
          getAllContractData?.disputeContactTab.addressChangedInd || '';
        disputeData.contactSeqNum =
          getAllContractData?.disputeContactTab.contactSeqNum || '';
        disputeData.contactTypeCd =
          getAllContractData?.disputeContactTab.contactTypeCd || null;
        disputeData.copySourceSeqNum =
          getAllContractData?.disputeContactTab.copySourceSeqNum || null;
        disputeData.corrLinkId =
          getAllContractData?.disputeContactTab.corrLinkId || null;
        disputeData.key =
          searchContractState.contractType === 'onSelect'
            ? getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                .contractSeqNum
            : maintainContractState.contractSeqNum;
        disputeData.keyTypeCd = 'CONTRACT';
        disputeData.lastUpdateDT = `${currDate} 00:00`;
        disputeData.lastUpdateUserID = logInUser;
        disputeData.nameChangedInd =
          getAllContractData?.disputeContactTab.nameChangedInd || null;
        disputeData.needsAttentionCd =
          getAllContractData?.disputeContactTab.needsAttentionCd || null;
      }
      const invoicedata = {};
      if (
        getAllContractData &&
        Object.keys(getAllContractData).length > 0 &&
        getAllContractData?.invoiceContactTab !== null &&
        Object.keys(getAllContractData?.invoiceContactTab).length > 0
      ) {
        // invoicedata = { ...invoiceContact };
        invoicedata.manufacturerID =
          getAllContractData?.invoiceContactTab.mfgId || '';
        invoicedata.manufacturerName =
          getAllContractData?.invoiceContactTab.mfgName || '';
        invoicedata.contactTypeCode =
          getAllContractData?.invoiceContactTab.contactTypeCd || '';
        invoicedata.description =
          getAllContractData?.invoiceContactTab.shortDescr || '';
        invoicedata.contactName =
          getAllContractData?.invoiceContactTab.contactName || '';
        invoicedata.corpName =
          getAllContractData?.invoiceContactTab.corpName || '';
        invoicedata.addrLine1 =
          getAllContractData?.invoiceContactTab.addrLine1 || '';
        invoicedata.addrLine2 =
          getAllContractData?.invoiceContactTab.addrLine2 || '';
        invoicedata.addrLine3 =
          getAllContractData?.invoiceContactTab.addrLine3 || '';
        invoicedata.city = getAllContractData?.invoiceContactTab.city || '';
        invoicedata.stateCd =
          getAllContractData?.invoiceContactTab.stateCd || '';
        invoicedata.zip = getAllContractData?.invoiceContactTab.zip || '';
        invoicedata.zip4 = getAllContractData?.invoiceContactTab.zip4 || '';
        invoicedata.phoneNum =
          getAllContractData?.invoiceContactTab.phoneNum || '';
        invoicedata.phoneExtension =
          getAllContractData?.invoiceContactTab.phoneExtension || '';
        invoicedata.faxNum = getAllContractData?.invoiceContactTab.faxNum || '';
        invoicedata.email = getAllContractData?.invoiceContactTab.email || '';
        invoicedata.addressChangedInd =
          getAllContractData?.invoiceContactTab.addressChangedInd || '';
        invoicedata.contactSeqNum =
          getAllContractData?.invoiceContactTab.contactSeqNum || '';
        invoicedata.contactTypeCd =
          getAllContractData?.invoiceContactTab.contactTypeCd || null;
        invoicedata.copySourceSeqNum =
          getAllContractData?.invoiceContactTab.copySourceSeqNum || null;
        invoicedata.corrLinkId =
          getAllContractData?.invoiceContactTab.corrLinkId || null;
        invoicedata.key =
          searchContractState.contractType === 'onSelect'
            ? getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                .contractSeqNum
            : maintainContractState.contractSeqNum;
        invoicedata.keyTypeCd = 'CONTRACT';
        invoicedata.lastUpdateDT = `${currDate} 00:00`;
        invoicedata.lastUpdateUserID = logInUser;
        invoicedata.nameChangedInd =
          getAllContractData?.invoiceContactTab.nameChangedInd || null;
        invoicedata.needsAttentionCd =
          getAllContractData?.invoiceContactTab.needsAttentionCd || null;
      }
      const calData = { ...calTab };
      if (
        getAllContractData &&
        Object.keys(getAllContractData).length > 0 &&
        getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
      ) {
        calData.cmsNdcInclInd =
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
            .cmsNdcInclInd == 1;
        calData.nonCmsNdcInclInd =
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
            .nonCmsNdcInclInd == 1;
        calData.contractCalcMethodCd =
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
            .contractCalcMethodCd || null;
        calData.calcNonInnovPct =
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
            .calcNonInnovPct || '';
        calData.calcInnovSinglePct =
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
            .calcInnovSinglePct || '';
      }
      const detailData = {};
      if (
        getAllContractData &&
        Object.keys(getAllContractData).length > 0 &&
        getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab !== null &&
        Object.keys(
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
        ).length > 0
      ) {
        detailData.useDefRpcInd =
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
            .useDefRpcInd == 1;
        detailData.detailInvoices =
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab.detailLevelOnInvoiceCd;
        detailData.disputeSpecialists =
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
            .contractDefDispSpecialist || '';
        detailData.letterSender =
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
            .letterSenderUserId || '';
        detailData.earliestQuarter =
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
            .earliestQtrForDrugDetails || null;
        detailData.sendToCommercialMfgInd =
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
            .sendToCommercialMfgInd == 1;
        detailData.writeOffDate = getAllContractData
          ?.cdetailsHeaderAndCalcAndMfgAndDetailsTab.writeOffDt
          ? moment(
              new Date(
                new Date(
                  getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab.writeOffDt
                ).toLocaleString('en-US', {
                  timeZone: process.env.REACT_APP_TIMEZONE,
                })
              )
            ).format('MM/DD/YYYY')
          : null;
      }
      const mfgData = {};
      if (
        getAllContractData &&
        Object.keys(getAllContractData).length > 0 &&
        getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab !== null &&
        Object.keys(
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
        ).length > 0
      ) {
        const mfgTab =
          getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab;
        const toDropdownValue = (value) =>
          value != null && value !== '' ? String(value) : '-1';
        mfgData.useDefMfgInd = mfgTab.useDefMfgInd ?? 0;
        mfgData.paperFinalQtr =
          handleQuarterFormate(mfgTab.paperFinalQtr) || '';
        mfgData.printImageFinalQtr =
          handleQuarterFormate(mfgTab.printImageFinalQtr) || '';
        mfgData.cmsElectFinalQtr =
          handleQuarterFormate(mfgTab.cmsElectFinalQtr) || '';
        mfgData.ncpdpSummaryFinalQtr =
          handleQuarterFormate(mfgTab.ncpdpSummaryFinalQtr) || '';
        mfgData.ncpdpClaimOwnFinalQtr =
          handleQuarterFormate(mfgTab.ncpdpClaimOwnFinalQtr) || '';
        mfgData.ncpdpClaimMbFinalQtr =
          handleQuarterFormate(mfgTab.ncpdpClaimMbFinalQtr) || '';
        mfgData.paperInd = mfgTab.paperInd ?? 0;
        mfgData.printImageInd = mfgTab.printImageInd ?? 0;
        mfgData.cmsElectInd = mfgTab.cmsElectInd ?? 0;
        mfgData.ncpdpSummaryInd = mfgTab.ncpdpSummaryInd ?? 0;
        mfgData.ncpdpClaimOwnInd = mfgTab.ncpdpClaimOwnInd ?? 0;
        mfgData.ncpdpClaimMbInd = mfgTab.ncpdpClaimMbInd ?? 0;
        mfgData.pricingTimingCd = toDropdownValue(mfgTab.pricingTimingCd);
        mfgData.enrollmentTimingCd = toDropdownValue(mfgTab.enrollmentTimingCd);
        mfgData.collectionMediumCd = toDropdownValue(mfgTab.collectionMediumCd);
      }
      const newdata = {
        ...maintainContractState,
        ...headerData,

        getAllOtherContract: getAllContractData?.otherContactTab
          ? getAllContractData?.otherContactTab
          : [],
        listOfOtherContact: noOfOtherContacts,
        otherContract: {
          ...otherContract,
          ...data,
        },
        disputeContract: {
          ...disputeContract,
          ...disputeData,
        },
        invoiceContact: {
          ...invoiceContact,
          ...invoicedata,
        },
        calTab: {
          ...calTab,
          ...calData,
        },
        detailTab: {
          ...detailTab,
          ...detailData,
        },
        manufacturerTab: {
          ...manufacturerTab,
          ...mfgData,
        },
      };
      dispatch(dispatchDeleteDrugFamily([]));
      dispatch(dispatchDeleteCoverageGap([]));
      dispatch(maintainContractActions(newdata));
      if (
        searchContractState.contractType === 'onSelect' &&
        getAllContractData &&
        getAllContractData?.drugFamilyGrid &&
        getAllContractData?.drugFamilyGrid.length > 0
      ) {
        const arr = [];
        const drugFamilies = getAllContractData?.drugFamilyGrid.map((item) => {
          const drugFamily = {};
          drugFamily.drugfamilyname = item.familyName;
          drugFamily.startquarter = item.startQtr;
          drugFamily.endquarter = item.endQtr;
          drugFamily.REBATE_PRICING_METHOD_CD = item.rebatePricingMethodCd;
          drugFamily.VOLUME_CALC_METHOD_CD = item.volumeCalcMethodCd;
          drugFamily.MKT_SHARE_CALC_METHOD_CD = item.mktShareCalcMethodCd;
          drugFamily.basketname = item.marketBasketName;
          drugFamily.NAT_MKT_SHARE_TYPE_CD = item.natMktShareTypeCd;
          drugFamily.sharegroup = item.marketShareId;
          drugFamily.subgroupid = item.subgroupId;
          drugFamily.comments = item.corrLinkId;
          drugFamily.corrLinkId = item.corrLinkId;
          drugFamily.action = '';
          drugFamily.contractFamilySeqNum = item.contractFamilySeqNum || null;
          drugFamily.familySeqNum = item.familySeqNum || null;
          drugFamily.marketBasketSeqNum = item.marketBasketSeqNum || null;
          drugFamily.marketShareId = item.marketShareId || null;
          drugFamily.endQtrErr = false;
          drugFamily.alreadyAdded = true;
          drugFamily.startQtrErr = false;
          drugFamily.rebateProgramCd =
            getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.rebateProgramCd;
          drugFamily.mfgId =
            getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.mfgId;
          arr.push(drugFamily);
        });
        dispatch(dispatchDrugTable(arr, '', '', 'onLoad'));
      }
      // Capture contact baselines after load dispatches so drug/coverage
      // population is never interrupted by contact dirty-state updates.
      setContactBaselines(
        newdata.invoiceContact,
        newdata.disputeContract,
        newdata.listOfOtherContact
      );
      if (callValidateContract) {
        validateContract('Save');
        setCallValidateContract(false);
      }
    } else if (getAllContractData?.error === 'API failed') {
      dispatch(
        handleErrorMessages([
          {
            fieldName: 'FailedAPI',
            errorType: 'FailedMessage',
            tabName: 'MainTab',
            message: constantMessageData.FAIL_PROCESSING_REQUEST,
          },
        ])
      );
      resetInitialField();
    }
    setLoading(false);
    setIsCancelOpen(false);
    if (getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab) {
      handleExistingCommentList(
        getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
      );
    }
  }, [getAllContractData]);
  const resetFieldData = () => {
    if (searchContractState.contractType !== 'onSelect') {
      resetInitialField();
    }
    if (searchContractState.contractType === 'onSelect') {
      dispatch(dispatchInitialResponse(true));
      setLoading(true);
      dispatch(dispatchCellClick(false));
      const newData = {
        searchType: selected_type,
        rebateProgram:
          selected_type === Constants.MANUFACTURER_REBATE_ID
            ? searchContractState.rebateProgramCode
            : null,
        quarter:
          selected_type === Constants.MANUFACTURER_REBATE_ID
            ? searchContractState.getQuarter
            : null,
        mfgId:
          searchContractState.selectedContractType === 'mfgId'
            ? searchContractState.selectedRowData
            : null,
        drugFamilyId:
          searchContractState.selectedContractType === 'drugFamilyId'
            ? searchContractState.selectedRowData
            : null,
        marketBasketId:
          searchContractState.selectedContractType === 'marketBasketId'
            ? searchContractState.selectedRowData
            : null,
        contractId: searchContractState.selectedContractId,
        // searchContractState.selectedContractType === 'contractId'
        //   ? searchContractState.selectedRowData
        //   : null,
        asOfDate:
          selected_type === Constants.MANUFACTURER_REBATE_ID
            ? null
            : searchContractState.searchContractDate,
        keyTypeCd: 'CONTRACT',
        planType: searchContractState.planType,
      };
      dispatch(getAllContractDetails(newData));
    }
    dispatch(handleErrorMessages([]));
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj1 =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/createContract') {
          item.isFormSave = false;
          item.isFormDirty = false;
          item.isFormError = false;
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
  };

  React.useEffect(() => {
    const headerData = {};
    setIsCancelOpen(false);
    if (
      initialResponse &&
      searchContractState.contractType === 'CreateContract'
    ) {
      resetFieldData();
      dispatch(dispatchInitialResponse(false));
      headerData.disableDrugFamilyTab =
        searchContractState.createPlanType == 'SUPP'
          ? false
          : searchContractState.createPlanType != 'COMM';
      headerData.disableCalTab = searchContractState.createPlanType == 'FD';
      headerData.disableCoverageTab =
        searchContractState.createPlanType != 'ST';
      headerData.rebateProgramCd = searchContractState?.createRebateProgramCode;
      headerData.mfgId = searchContractState?.selectedRowData;
      if (headerData.disableDrugFamilyTab && headerData.disableCalTab) {
        dispatch(dispatchTabValue('three'));
      } else if (headerData.disableDrugFamilyTab)
        dispatch(dispatchTabValue('two'));
      else dispatch(dispatchTabValue('one'));
      if (
        searchContractState.contractType === 'CreateContract' &&
        searchContractState?.selectedCreateMfgRowData &&
        Object.keys(searchContractState?.selectedCreateMfgRowData).length > 0
      ) {
        const arr = [];
        const drugFamilies = searchContractState?.selectedCreateMfgRowData.map(
          (item) => {
            const drugFamily = {};
            drugFamily.drugfamilyname = item.drugfamilyname;
            drugFamily.startquarter = '';
            drugFamily.endquarter = '';
            drugFamily.REBATE_PRICING_METHOD_CD = '-1';
            drugFamily.VOLUME_CALC_METHOD_CD = '-1';
            drugFamily.MKT_SHARE_CALC_METHOD_CD = '-1';
            drugFamily.basketname = '-1';
            drugFamily.NAT_MKT_SHARE_TYPE_CD = '-1';
            drugFamily.sharegroup = '';
            drugFamily.subgroupid = '';
            drugFamily.comments = '';
            drugFamily.action = '';
            drugFamily.contractFamilySeqNum = item.contractFamilySeqNum || null;
            drugFamily.familySeqNum = item.familySeqNum;
            drugFamily.marketBasketSeqNum = '';
            drugFamily.marketShareId = '';
            drugFamily.endQtrErr = false;
            drugFamily.startQtrErr = false;
            drugFamily.alreadyAdded = false;
            drugFamily.rebateProgramCd =
              searchContractState?.createRebateProgramCode;
            drugFamily.mfgId = searchContractState?.selectedRowData;
            arr.push(drugFamily);
          }
        );
        dispatch(dispatchDrugTable(arr, '', '', 'onLoad'));
      }
    }
    const noOfOtherContacts = [];
    if (
      getContactType &&
      getContactType.length > 0 &&
      searchContractState.contractType === 'CreateContract'
    ) {
      const otherCon = getContactType.map((item, index) => {
        const data = {};
        data.contactTypeCd = item.contactTypeCd;
        data.contactName = '';
        data.corpName = '';
        data.addrLine1 = '';
        data.addrLine2 = '';
        data.addrLine3 = '';
        data.city = '';
        data.stateCd = '';
        data.zip = '';
        data.zip4 = '';
        data.phoneNum = '';
        data.phoneExtension = '';
        data.faxNum = '';
        data.email = '';
        data.addressChangedInd = null;
        data.contactSeqNum = null;
        data.copySourceSeqNum = null;
        data.corrLinkId = null;
        data.key = maintainContractState.contractSeqNum;
        data.keyTypeCd = 'CONTRACT';
        data.lastUpdateDT = `${currDate} 00:00`;
        data.lastUpdateUserID = logInUser;
        data.nameChangedInd = null;
        data.needsAttentionCd = null;
        noOfOtherContacts.push(data);
      });
    }
    const newdata = {
      ...maintainContractState,
      ...headerData,
      getAllOtherContract: getAllContractData?.otherContactTab
        ? getAllContractData?.otherContactTab
        : [],
      listOfOtherContact: noOfOtherContacts,
    };
    dispatch(maintainContractActions(newdata));
  }, [getContactType]);

  const onCancel = () => {
    dispatch(getDrugSpecialist(''));
    dispatch(getLetterSenderDetails(''));
    dispatch(
      getContractContactType({
        keyTypeCd: 'CONTRACT',
      })
    );
    dispatch(errorMaintainContractActions([]));
    dispatch(dispatchAllContractDetails({}));
    resetFieldData();
    if (searchContractState.contractType === 'onSelect') {
      setLoading(true);
      const newData = {
        searchType: selected_type,
        rebateProgram:
          selected_type === Constants.MANUFACTURER_REBATE_ID
            ? searchContractState.rebateProgramCode
            : null,
        quarter:
          selected_type === Constants.MANUFACTURER_REBATE_ID
            ? searchContractState.getQuarter
            : null,
        mfgId:
          searchContractState.selectedContractType === 'mfgId'
            ? searchContractState.selectedRowData
            : null,
        drugFamilyId:
          searchContractState.selectedContractType === 'drugFamilyId'
            ? searchContractState.selectedRowData
            : null,
        marketBasketId:
          searchContractState.selectedContractType === 'marketBasketId'
            ? searchContractState.selectedRowData
            : null,
        contractId: searchContractState.selectedContractId,
        // searchContractState.selectedContractType === 'contractId'
        //   ? searchContractState.selectedRowData
        //   : null,
        asOfDate:
          selected_type === Constants.MANUFACTURER_REBATE_ID
            ? null
            : searchContractState.searchContractDate,
        keyTypeCd: 'CONTRACT',
        planType: searchContractState.planType,
      };
      dispatch(getAllContractDetails(newData));
    } else {
      dispatch(dispatchAllContractDetails({}));
    }
  };

  const onCloseDuplicateContract = () => {
    setDuplicateContractPopUp(false);
    setOpenDuplicatePop(false);
  };
  React.useEffect(() => {
    if (
      newContractSeqNum &&
      newContractSeqNum !== null &&
      newContractSeqNum !== ''
    ) {
      setLoading(false);
      openSave(true);
    }
  }, [newContractSeqNum]);
  const onClickDuplicateContractDialog = (
    fromDate,
    todate,
    rebateProgram,
    drugPricing
  ) => {
    setFormValue({
      ...formValue,
      fromDate: fromDate,
      toDate: todate,
      rebateProgramCode: rebateProgram,
      drugPricing: drugPricing,
    });
    setLoading(true);
    setOpenDuplicatePop(false);
    setDuplicateAction(true);
    dispatch(getNewContractSequenceNum());
  };
  // redirect To rebate program screen
  React.useEffect(() => {
    if (rebatePgmView && rebatePgmView.status === '001') {
      if (maintainContractState.gotoRebatePgm) {
        const headerData = {};
        headerData.gotoRebatePgm = false;
        const newdata = {
          ...maintainContractState,
          ...headerData,
        };
        dispatch(maintainContractActions(newdata));
        localStorage.setItem('viewpgmdetails', 'true');
        redirectURLLink(
          '/maintainRebate',
          'Maintain Rebate Program',
          history,
          dispatch
        );
      }
    }
  }, [rebatePgmView]);
  return (
    <div
      className="tBillPanel tabs-container frr-contract"
      data-testid="Create-Contact-component"
    >
      <SaveCancelPopup
        open={isSaveOpen}
        title="Save"
        data-testid="masterSave"
        onConfim={() => masterDataSave()}
        onCancel={() => setIsSaveOpen(false)}
      />
      <SaveCancelPopup
        open={isCancelOpen}
        title="Cancel"
        data-testid="masterSave1"
        onConfim={onCancel}
        onCancel={() => setIsCancelOpen(false)}
      />
      <Spinner load={loading} />
      <div>
        <div className="align-item-center d-flex justify-content-between">
          <CustomSeparator parent1="Maintain" parent2="Maintain Contract" />
          {!fullScreenView && (
            <div>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="action-tooltip">Action</Tooltip>}
              >
                <Dropdown className="icon-dropdown-container frr-lab-diff-action-icon-container">
                  <Dropdown.Toggle
                    className="icon-dropdown"
                    aria-label="Show Contracts using this Contact"
                  >
                    <SVGComponent iconName="Icon-export" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      role="button"
                      data-testid="duplicateContract"
                      disabled={
                        searchContractState.contractType === 'onSelect'
                          ? getAllContractData?.planTypeCd == 'FD'
                          : false
                      }
                      onClick={handleDuplicate}
                    >
                      Duplicate
                    </Dropdown.Item>
                    <Dropdown.Item
                      role="button"
                      data-testid="validateContract"
                      onClick={() => {
                        validateContract();
                      }}
                      disabled={!isEnablebyRole}
                    >
                      Validate Contract
                    </Dropdown.Item>
                    <Dropdown.Item
                      role="button"
                      data-testid="goToManufacturer"
                      onClick={() => {
                        goToManufacturer();
                      }}
                    >
                      Go to Manufacturer
                    </Dropdown.Item>
                    <Dropdown.Item
                      role="button"
                      data-testid="writeOff"
                      onClick={() => {
                        dispatch(
                          getRebatePgmDetail({
                            planType:
                              searchContractState.contractType === 'onSelect'
                                ? getAllContractData?.planTypeCd
                                : searchContractState?.createPlanType,
                            // searchContractState.planType,
                            rebateProg:
                              searchContractState.contractType === 'onSelect'
                                ? getAllContractData
                                    ?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                                    ?.rebateProgramCd
                                : searchContractState?.createRebateProgramCode,
                          })
                        );
                        const headerData = {};
                        headerData.gotoRebatePgm = true;
                        const newdata = {
                          ...maintainContractState,
                          ...headerData,
                        };
                        dispatch(maintainContractActions(newdata));
                      }}
                    >
                      Go to Rebate Program
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </OverlayTrigger>
            </div>
          )}
        </div>
        {!fullScreenView && (
          <>
            {maintainContractState?.showSaveButton === 'No' ? (
              <DisplaySuccessMessages successMessages={successMessage} />
            ) : (
              ''
            )}

            <DisplayErrorMessages
              errorMessages={[
                ...new Set(
                  errorMessagesFromRedux?.length > 0
                    ? _.map(errorMessagesFromRedux, (l) => l.message)
                    : []
                ),
              ]}
            />
            <div className="row">
              <div
                className="col-12 mui-custom-form no-margin"
                style={{ width: '100%' }}
              >
                <fieldset className="custom-fieldset custom-height">
                  <legend aria-hidden="true" className="d-none" />
                  <div className="form-wrapper db">
                    <div className="row">
                      <div className="col-3 col-sm-6 col-md-3">
                        <div className="form-wrapper vertical-wrapper">
                          <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                            <TextField
                              data-testid="contract-id-textField"
                              id="contract-id"
                              disabled
                              label="Contract ID "
                              fullWidth
                              placeholder=""
                              inputProps={{ maxLength: 38 }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={
                                getAllContractData
                                  ?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                                  ?.contractSeqNum
                                  ? getAllContractData
                                      ?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                                      ?.contractSeqNum
                                  : maintainContractState.contractSeqNum
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-3 col-sm-6 col-md-3">
                        <div className="form-wrapper vertical-wrapper">
                          <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                            {searchContractState.contractType === 'onSelect' &&
                            maintainContractState?.contractName?.length > 20 ? (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="com-tooltip">
                                    {maintainContractState?.contractName}
                                  </Tooltip>
                                }
                              >
                                <TextField
                                  data-testid="contract-name-textField"
                                  id="contract-name"
                                  label="Contract Name "
                                  className="mandate-fields"
                                  fullWidth
                                  placeholder=""
                                  inputProps={{ maxLength: 40 }}
                                  autoFocus={
                                    searchContractState.contractType !==
                                    'onSelect'
                                  }
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  required
                                  disabled={!isEnablebyRole}
                                  value={`${maintainContractState?.contractName.substring(
                                    0,
                                    23
                                  )}...`}
                                  onChange={(e) => {
                                    handleOnChangeEvent(e, 'contractName');
                                  }}
                                  onBlur={(e) => {
                                    handleOnBlurEventFields(e, 'contractName');
                                  }}
                                  helperText={
                                    errorMessagesFromRedux?.length > 0
                                      ? [
                                          ...new Set(
                                            errorMessagesFromRedux
                                              ?.filter(
                                                (x) =>
                                                  x.fieldName === 'contractName'
                                              )
                                              .map((item) => {
                                                return item.message;
                                              })
                                          ),
                                        ]
                                      : null
                                  }
                                  error={
                                    errorMessagesFromRedux?.length > 0 &&
                                    errorMessagesFromRedux?.filter(
                                      (x) => x.fieldName === 'contractName'
                                    ).length > 0
                                      ? [
                                          ...new Set(
                                            errorMessagesFromRedux
                                              ?.filter(
                                                (x) =>
                                                  x.fieldName === 'contractName'
                                              )
                                              .map((item) => {
                                                return item.message;
                                              })
                                          ),
                                        ]
                                      : false
                                  }
                                />
                              </OverlayTrigger>
                            ) : (
                              <TextField
                                data-testid="contract-name-textField"
                                id="contract-name"
                                label="Contract Name "
                                className="mandate-fields"
                                fullWidth
                                placeholder=""
                                inputProps={{ maxLength: 40 }}
                                autoFocus={
                                  searchContractState.contractType !==
                                  'onSelect'
                                }
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                required
                                disabled={!isEnablebyRole}
                                value={maintainContractState?.contractName}
                                onChange={(e) => {
                                  handleOnChangeEvent(e, 'contractName');
                                }}
                                onBlur={(e) => {
                                  handleOnBlurEventFields(e, 'contractName');
                                }}
                                helperText={
                                  errorMessagesFromRedux?.length > 0
                                    ? [
                                        ...new Set(
                                          errorMessagesFromRedux
                                            ?.filter(
                                              (x) =>
                                                x.fieldName === 'contractName'
                                            )
                                            .map((item) => {
                                              return item.message;
                                            })
                                        ),
                                      ]
                                    : null
                                }
                                error={
                                  errorMessagesFromRedux?.length > 0 &&
                                  errorMessagesFromRedux?.filter(
                                    (x) => x.fieldName === 'contractName'
                                  ).length > 0
                                    ? [
                                        ...new Set(
                                          errorMessagesFromRedux
                                            ?.filter(
                                              (x) =>
                                                x.fieldName === 'contractName'
                                            )
                                            .map((item) => {
                                              return item.message;
                                            })
                                        ),
                                      ]
                                    : false
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-3 col-sm-6 col-md-3">
                        <div className="form-wrapper vertical-wrapper">
                          <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                            <TextField
                              data-testid="manufacturer-id-textField"
                              id="manufacturer-id"
                              disabled
                              label="Manufacturer ID "
                              fullWidth
                              placeholder=""
                              value={
                                searchContractState.contractType === 'onSelect'
                                  ? maintainContractState?.mfgId
                                  : searchContractState?.selectedRowData
                              }
                              inputProps={{ maxLength: 10 }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-3 col-sm-6 col-md-3">
                        <div className="form-wrapper vertical-wrapper">
                          <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                            {getAllContractData
                              ?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                              ?.mfgName?.length > 20 ||
                            searchContractState?.selectedMfgName?.length >
                              20 ? (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="com-tooltip">
                                    {searchContractState.contractType ===
                                    'onSelect'
                                      ? getAllContractData
                                          ?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                                          ?.mfgName
                                      : searchContractState?.selectedMfgName}
                                  </Tooltip>
                                }
                              >
                                <TextField
                                  data-testid="manufacturer-name-textField"
                                  id="manufacturer-name"
                                  disabled
                                  label="Manufacturer Name"
                                  fullWidth
                                  placeholder=""
                                  value={
                                    searchContractState.contractType ===
                                    'onSelect'
                                      ? `${getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.mfgName.substring(
                                          0,
                                          20
                                        )}...`
                                      : `${searchContractState?.selectedMfgName.substring(
                                          0,
                                          20
                                        )}...`
                                  }
                                  inputProps={{ maxLength: 120 }}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                />
                              </OverlayTrigger>
                            ) : (
                              <TextField
                                data-testid="manufacturer-name-textField"
                                id="manufacturer-name"
                                disabled
                                label="Manufacturer Name"
                                fullWidth
                                placeholder=""
                                value={
                                  searchContractState.contractType ===
                                  'onSelect'
                                    ? maintainContractState?.mfgName
                                    : searchContractState?.selectedMfgName
                                }
                                inputProps={{ maxLength: 120 }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3 col-sm-6 col-md-3">
                        <div className="mui-custom-form input-md">
                          <TextField
                            data-testid="rebateprogram-code-textField"
                            id="rebateprogram-code"
                            disabled
                            label="Rebate Program Code "
                            fullWidth
                            placeholder=""
                            value={
                              searchContractState.contractType === 'onSelect'
                                ? maintainContractState?.rebateProgramCd
                                : searchContractState?.createRebateProgramCode
                            }
                            inputProps={{ maxLength: 10 }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-3 col-sm-6 col-md-3">
                        <div className="mui-custom-form input-md">
                          {getAllContractData
                            ?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                            ?.shortDescr?.length > 20 ||
                          searchContractState?.createRebateProgramCode?.length >
                            20 ? (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="com-tooltip">
                                  {searchContractState.contractType ===
                                  'onSelect'
                                    ? maintainContractState?.shortDescr
                                    : searchContractState?.createRebateProgramCode}
                                </Tooltip>
                              }
                            >
                              <TextField
                                data-testid="description-textField"
                                id="description"
                                disabled
                                label="Description"
                                fullWidth
                                placeholder=""
                                value={
                                  searchContractState.contractType ===
                                  'onSelect'
                                    ? maintainContractState?.shortDescr
                                    : searchContractState?.createRebateProgramCode
                                }
                                inputProps={{ maxLength: 30 }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </OverlayTrigger>
                          ) : (
                            <TextField
                              data-testid="description-textField"
                              id="description"
                              disabled
                              label="Description"
                              fullWidth
                              placeholder=""
                              value={
                                searchContractState.contractType === 'onSelect'
                                  ? maintainContractState?.shortDescr
                                  : searchContractState?.createRebateProgramCode
                              }
                              inputProps={{ maxLength: 30 }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-3 col-sm-6 col-md-3">
                        <div className="mui-custom-form input-md">
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              required
                              data-testid="start-date"
                              className="mandate-fields"
                              id="contractStartDate"
                              label="Start Date"
                              format={dateFormatForDatePicker}
                              inputFormat={dateFormatForDatePicker}
                              mask="__/__/____"
                              minDate={MinDate}
                              maxDate={MaxDate}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              disabled={
                                !isEnablebyRole ||
                                !!(
                                  searchContractState.contractType ===
                                    'onSelect' &&
                                  getAllContractData?.planTypeCd == 'FD'
                                )
                              }
                              InputProps={{
                                readOnly: false,
                                autoFill: false,
                              }}
                              onKeyDown={async (e) => {
                                if (e.keyCode == 67) {
                                  // copy date
                                  await window.navigator?.clipboard.writeText(
                                    e?.target?.value
                                  );
                                }
                              }}
                              placeholder="mm/dd/yyyy"
                              value={maintainContractState.contractStartDate}
                              onChange={(d) => {
                                onChangeDateField(d, 'contractStartDate');
                              }}
                              onBlur={(e) => {
                                handleOnBlurDateEvent(e, 'contractStartDate');
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'contract Start Date',
                              }}
                              helperText={
                                errorMessagesFromRedux?.length > 0
                                  ? [
                                      ...new Set(
                                        errorMessagesFromRedux
                                          ?.filter(
                                            (x) =>
                                              x.fieldName ===
                                              'contractStartDate'
                                          )
                                          .map((item) => {
                                            return item.message;
                                          })
                                      ),
                                    ]
                                  : null
                              }
                              error={
                                errorMessagesFromRedux?.length > 0 &&
                                errorMessagesFromRedux?.filter(
                                  (x) => x.fieldName === 'contractStartDate'
                                ).length > 0
                                  ? [
                                      ...new Set(
                                        errorMessagesFromRedux
                                          ?.filter(
                                            (x) =>
                                              x.fieldName ===
                                              'contractStartDate'
                                          )
                                          .map((item) => {
                                            return item.message;
                                          })
                                      ),
                                    ]
                                  : false
                              }
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                      </div>
                      <div className="col-3 col-sm-6 col-md-3">
                        <div className="mui-custom-form input-md">
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              data-testid="contractEndDate"
                              className="mandate-fields"
                              id="contractEndDate"
                              label="End Date"
                              format={dateFormatForDatePicker}
                              inputFormat={dateFormatForDatePicker}
                              mask="__/__/____"
                              maxDate={MaxDate}
                              minDate={
                                new Date(
                                  maintainContractState.contractStartDate
                                )
                              }
                              InputLabelProps={{
                                shrink: true,
                              }}
                              InputProps={{
                                readOnly: false,
                                autoFill: false,
                              }}
                              disabled={
                                !isEnablebyRole ||
                                !!(
                                  searchContractState.contractType ===
                                    'onSelect' &&
                                  getAllContractData?.planTypeCd == 'FD'
                                )
                              }
                              placeholder="mm/dd/yyyy"
                              value={maintainContractState.contractEndDate}
                              onChange={(d) => {
                                onChangeDateField(d, 'contractEndDate');
                              }}
                              onBlur={(e) => {
                                handleOnBlurDateEvent(e, 'contractEndDate');
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'contract End Date',
                              }}
                              helperText={
                                errorMessagesFromRedux?.length > 0
                                  ? [
                                      ...new Set(
                                        errorMessagesFromRedux
                                          ?.filter(
                                            (x) =>
                                              x.fieldName === 'contractEndDate'
                                          )
                                          .map((item) => {
                                            return item.message;
                                          })
                                      ),
                                    ]
                                  : null
                              }
                              error={
                                errorMessagesFromRedux?.length > 0 &&
                                errorMessagesFromRedux?.filter(
                                  (x) => x.fieldName === 'contractEndDate'
                                ).length > 0
                                  ? [
                                      ...new Set(
                                        errorMessagesFromRedux
                                          ?.filter(
                                            (x) =>
                                              x.fieldName === 'contractEndDate'
                                          )
                                          .map((item) => {
                                            return item.message;
                                          })
                                      ),
                                    ]
                                  : false
                              }
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3 col-sm-6 col-md-3">
                        <div className="mui-custom-form input-md">
                          <TextField
                            data-testid="contract-status-textField"
                            id="contract-status"
                            label="Contract Status"
                            disabled
                            fullWidth
                            value={
                              searchContractState.contractType === 'onSelect'
                                ? getAllContractData
                                    ?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                                    ?.contractValidInd === 1
                                  ? 'Valid'
                                  : 'Invalid'
                                : 'Invalid'
                            }
                            placeholder=""
                            inputProps={{ maxLength: 6 }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-3 col-sm-6 col-md-3">
                        <div className="mui-custom-form input-md">
                          <div className="comment-sec frr-mt-37">
                            Comments &nbsp;
                            <img
                              role="button"
                              data-testid=" imgButton "
                              disabled={
                                searchContractState.contractType !== 'onSelect'
                              }
                              onClick={() => {
                                if (
                                  searchContractState.contractType ===
                                  'onSelect'
                                ) {
                                  setShowComments(true);
                                }
                              }}
                              alt=" comment "
                              tabIndex={'0'}
                              onKeyDown={(e) => {
                                // Handle Enter and Space key events
                                if (e.key === 'Enter' || e.key === ' ') {
                                  e.preventDefault(); // Prevents the default space scrolling behavior
                                  if (
                                    searchContractState.contractType ===
                                    'onSelect'
                                  ) {
                                    setShowComments(true);
                                  }
                                }
                              }}
                              src={
                                commentShow ? CommentVisibleIcon : CommentIcon
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div className="row mt-4 mb-3">
              <div className="col-12">
                <div className="btn-wrapper float-right">
                  {searchContractState.contractType !== 'CreateContract' && (
                    <Button
                      className="btn btn-success btn-save btn-primary"
                      data-testid="view-history"
                      type="button"
                      tabIndex="0"
                      onClick={() => {
                        handleViewHistory();
                      }}
                    >
                      <SVGComponent iconName="Icon-view-history" /> View History
                    </Button>
                  )}
                  <Button
                    className="btn btn-success btn-save"
                    data-testid="open_Save1"
                    onClick={() => {
                      onSubmit(true);
                    }}
                    disabled={isSaveDisabled}
                  >
                    <SVGComponent iconName="Icon-awesome-save" />
                    Save
                  </Button>
                  <Button
                    className="btn btn-cancel"
                    data-testid="open_Cancel1"
                    disabled={isSaveDisabled}
                    onClick={() => {
                      setIsCancelOpen(true);
                    }}
                  >
                    <SVGComponent iconName="Icon-cancel" />
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
            <div className="frr-tabs-wrapper custom-check">
              <AppBar
                position="static"
                sx={{ width: '100%' }}
                style={{ borderBottom: '1px solid #c9c8c5' }}
              >
                <Tabs
                  data-testid="handleChange"
                  value={tabValue}
                  onChange={handleChangeTabValue}
                  color="red"
                  style={{ color: RedColor }}
                  scrollButtons="auto"
                  variant="scrollable"
                >
                  <Tab
                    style={{ textTransform: 'capitalize' }}
                    value="one"
                    label=" Drug Families"
                    data-testid="drug-families"
                    disabled={maintainContractState.disableDrugFamilyTab}
                    tabIndex={0}
                  />
                  {errorMessagesFromRedux?.filter((x) => {
                    return x.tabName === 'DrugFamily';
                  }).length > 0 && <span className="tab-error">!</span>}
                  <Tab
                    style={{ textTransform: 'capitalize' }}
                    tabIndex={0}
                    value="two"
                    label="Calc"
                    data-testid="Calc"
                    disabled={maintainContractState.disableCalTab}
                  />
                  <Tab
                    style={{ textTransform: 'capitalize' }}
                    tabIndex={0}
                    value="three"
                    label="Manufacturer"
                    data-testid="manufacturer"
                  />
                  {errorMessagesFromRedux?.filter((x) => {
                    return x.tabName === 'Manufacturer';
                  }).length > 0 && <span className="tab-error">!</span>}
                  <Tab
                    style={{ textTransform: 'capitalize' }}
                    tabIndex={0}
                    value="four"
                    label="Detail"
                    data-testid="detail"
                  />
                  {errorMessagesFromRedux?.filter((x) => {
                    return x.tabName === 'DetailTab';
                  }).length > 0 && <span className="tab-error">!</span>}
                  <Tab
                    style={{ textTransform: 'capitalize' }}
                    tabIndex={0}
                    value="five"
                    label="Invoice Contact"
                    data-testid="Invoice-contact"
                    aria-label="Invoice Contact Tab"
                  />
                  {errorMessagesFromRedux?.filter((x) => {
                    return x.tabName === 'InvoiceContact';
                  }).length > 0 && <span className="tab-error">!</span>}
                  <Tab
                    style={{ textTransform: 'capitalize' }}
                    tabIndex={0}
                    value="six"
                    label="Dispute Contact"
                    data-testid="dispute-contact"
                  />
                  {errorMessagesFromRedux?.filter((x) => {
                    return x.tabName === 'DisputeContact';
                  }).length > 0 && <span className="tab-error">!</span>}
                  <Tab
                    style={{ textTransform: 'capitalize' }}
                    tabIndex={0}
                    value="seven"
                    label="Other Contacts"
                    data-testid="other-contacts"
                  />
                  {errorMessagesFromRedux?.filter((x) => {
                    return x.tabName === 'OtherContact';
                  }).length > 0 && <span className="tab-error">!</span>}
                  <Tab
                    style={{ textTransform: 'capitalize' }}
                    tabIndex={0}
                    value="eight"
                    label="Coverage gap"
                    data-testid="Cover-gap"
                    disabled={maintainContractState.disableCoverageTab}
                  />
                  {errorMessagesFromRedux?.filter((x) => {
                    return x.tabName === 'CoverageGap';
                  }).length > 0 && <span className="tab-error">!</span>}
                </Tabs>
              </AppBar>
            </div>
          </>
        )}
        <div className="tabs-body">
          {tabValue === 'one' && (
            <Drugfamilies
              setFullScreenView={setFullScreenView}
              fullScreenView={fullScreenView}
            />
          )}
          {tabValue === 'two' && <Calc isEnablebyRole={isEnablebyRole} />}
          {tabValue === 'three' && (
            <ContractManufacturer isEnablebyRole={isNormalUserTabEditable} />
          )}
          {tabValue === 'four' && <Detail />}
          {tabValue === 'five' && (
            <InvoiceContact isEnablebyRole={isEnablebyRole} />
          )}
          {tabValue === 'six' && (
            <DisputeContact isEnablebyRole={isEnablebyRole} />
          )}
          {tabValue === 'seven' && (
            <OtherContact isEnablebyRole={isNormalUserTabEditable} />
          )}
          {tabValue === 'eight' && (
            <CoverageGap
              setFullScreenView={setFullScreenView}
              fullScreenView={fullScreenView}
              isEnablebyRole={isEnablebyRole}
            />
          )}
        </div>
        {!fullScreenView && (
          <div className="row mt-4 mb-3">
            <div className="col-12">
              <div className="btn-wrapper float-right">
                <Button
                  className="btn btn-success btn-save"
                  data-testid="open_Save2"
                  onClick={() => {
                    onSubmit(true);
                  }}
                  disabled={isSaveDisabled}
                >
                  <SVGComponent iconName="Icon-awesome-save" />
                  Save
                </Button>
                <Button
                  className="btn btn-cancel"
                  data-testid="open_Cancel2"
                  disabled={isSaveDisabled}
                  onClick={() => {
                    setIsCancelOpen(true);
                  }}
                >
                  <SVGComponent iconName="Icon-cancel" />
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
      <CommonModal
        open={createValidate}
        className="dialogPanel custom-check dialog-500"
        viewAction
        viewHeader
        modalTitle="Validating the Contract"
        okTitle="Ok"
        data-testid="commomModal1"
        closeTitle="Cancel"
        removeClassName
        childrenComponent={
          <>Do you want Save the changes before validating the contract?</>
        }
        onOk={() => {
          handleValidateContract();
        }}
        onClose={() => setCreateValidate(false)}
      />
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          data-testid="viewHistory"
          tableName="CONTRACT"
          keyValue={keyValue}
        />
      )}
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="CONTRACT"
          corrLinkId={corrLinkId}
        />
      ) : null}
      <CommonModal
        open={duplicatePop}
        viewAction
        viewHeader
        data-testid="commomModal2"
        className="dialogPanel custom-check dialog-500"
        onOk={() => {
          setDuplicatePopUp(false);
          setDuplicateContractPopUp(true);
          setClickOncloseTabBtn(true);
          masterDataSave();
        }}
        okTitle="Ok"
        onClose={() => {
          setDuplicatePopUp(false);
        }}
        closeTitle="Cancel"
        modalTitle="Contract Details"
        childrenComponent={
          <div>
            <p>
              This will Duplicate the current contract and contract drug
              families. This action cannot be undone. The present window will be
              saved automatically. Do you wish to continue?
            </p>
          </div>
        }
      />
      <CommonModal
        open={duplicateContractPopUp}
        viewAction
        viewHeader
        data-testid="commomModal3"
        modalTitle="Duplicate Contract"
        className="dialogPanel custom-check dialog-500"
        onClose={onCloseDuplicateContract}
        childrenComponent={
          <DuplicateContractModal
            onClickDuplicateContractDialog={(
              fdate,
              tDate,
              rebateProg,
              drugPricing
            ) =>
              onClickDuplicateContractDialog(
                fdate,
                tDate,
                rebateProg,
                drugPricing
              )
            }
            onCloseDuplicateContract={onCloseDuplicateContract}
            planType={
              searchContractState.contractType === 'onSelect'
                ? getAllContractData?.planTypeCd
                : searchContractState.createPlanType
            }
          />
        }
      />
    </div>
  );
};
export default CreateContact;
